/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './../../pages/__root'
import { Route as SignedOutRouteImport } from './../../pages/signed-out'
import { Route as LoginRouteImport } from './../../pages/login'
import { Route as AccountNotLinkedRouteImport } from './../../pages/account-not-linked'
import { Route as AppRouteRouteImport } from './../../pages/_app/route'
import { Route as IndexRouteImport } from './../../pages/index'
import { Route as AppSettingsIndexRouteImport } from './../../pages/_app/settings/index'
import { Route as AppDashboardIndexRouteImport } from './../../pages/_app/dashboard/index'
import { Route as AppUserManagementUsersRouteRouteImport } from './../../pages/_app/user-management/users/route'
import { Route as AppSalesRepresentativesRouteRouteImport } from './../../pages/_app/sales/representatives/route'
import { Route as AppSalesOffersRouteRouteImport } from './../../pages/_app/sales/offers/route'
import { Route as AppSalesOfferTemplatesRouteRouteImport } from './../../pages/_app/sales/offer-templates/route'
import { Route as AppSalesLeadsRouteRouteImport } from './../../pages/_app/sales/leads/route'
import { Route as AppSalesExpedientsRouteRouteImport } from './../../pages/_app/sales/expedients/route'
import { Route as AppSalesClientsRouteRouteImport } from './../../pages/_app/sales/clients/route'
import { Route as AppEngineeringSuppliersRouteRouteImport } from './../../pages/_app/engineering/suppliers/route'
import { Route as AppEngineeringServicesRouteRouteImport } from './../../pages/_app/engineering/services/route'
import { Route as AppEngineeringMaterialsRouteRouteImport } from './../../pages/_app/engineering/materials/route'
import { Route as AppEngineeringMaterialFunctionsRouteRouteImport } from './../../pages/_app/engineering/material-functions/route'
import { Route as AppAdminUsersRouteRouteImport } from './../../pages/_app/admin/users/route'
import { Route as AppUserManagementUsersIndexRouteImport } from './../../pages/_app/user-management/users/index'
import { Route as AppSalesRepresentativesIndexRouteImport } from './../../pages/_app/sales/representatives/index'
import { Route as AppSalesOffersIndexRouteImport } from './../../pages/_app/sales/offers/index'
import { Route as AppSalesOfferTemplatesIndexRouteImport } from './../../pages/_app/sales/offer-templates/index'
import { Route as AppSalesLeadsIndexRouteImport } from './../../pages/_app/sales/leads/index'
import { Route as AppSalesExpedientsIndexRouteImport } from './../../pages/_app/sales/expedients/index'
import { Route as AppSalesClientsIndexRouteImport } from './../../pages/_app/sales/clients/index'
import { Route as AppEngineeringSuppliersIndexRouteImport } from './../../pages/_app/engineering/suppliers/index'
import { Route as AppEngineeringServicesIndexRouteImport } from './../../pages/_app/engineering/services/index'
import { Route as AppEngineeringMaterialsIndexRouteImport } from './../../pages/_app/engineering/materials/index'
import { Route as AppEngineeringMaterialFunctionsIndexRouteImport } from './../../pages/_app/engineering/material-functions/index'
import { Route as AppDiagramDiagramIdIndexRouteImport } from './../../pages/_app/diagram/$diagramId/index'
import { Route as AppDevDashboardIndexRouteImport } from './../../pages/_app/dev/dashboard/index'
import { Route as AppAdminUsersIndexRouteImport } from './../../pages/_app/admin/users/index'
import { Route as AppUserManagementUsersRolesRouteRouteImport } from './../../pages/_app/user-management/users/roles/route'
import { Route as AppUserManagementUsersUserIdRouteRouteImport } from './../../pages/_app/user-management/users/$userId/route'
import { Route as AppSalesRepresentativesRepresentativeIdRouteRouteImport } from './../../pages/_app/sales/representatives/$representativeId/route'
import { Route as AppSalesOffersTemplatesRouteRouteImport } from './../../pages/_app/sales/offers/templates/route'
import { Route as AppSalesOffersOfferIdRouteRouteImport } from './../../pages/_app/sales/offers/$offerId/route'
import { Route as AppSalesLeadsLeadIdRouteRouteImport } from './../../pages/_app/sales/leads/$leadId/route'
import { Route as AppSalesExpedientsExpedientIdRouteRouteImport } from './../../pages/_app/sales/expedients/$expedientId/route'
import { Route as AppSalesClientsClientIdRouteRouteImport } from './../../pages/_app/sales/clients/$clientId/route'
import { Route as AppEngineeringSuppliersFunctionsRouteRouteImport } from './../../pages/_app/engineering/suppliers/functions/route'
import { Route as AppEngineeringSuppliersSupplierIdRouteRouteImport } from './../../pages/_app/engineering/suppliers/$supplierId/route'
import { Route as AppEngineeringServicesFunctionsRouteRouteImport } from './../../pages/_app/engineering/services/functions/route'
import { Route as AppEngineeringServicesServiceIdRouteRouteImport } from './../../pages/_app/engineering/services/$serviceId/route'
import { Route as AppEngineeringMaterialsFunctionsRouteRouteImport } from './../../pages/_app/engineering/materials/functions/route'
import { Route as AppEngineeringMaterialsMaterialIdRouteRouteImport } from './../../pages/_app/engineering/materials/$materialId/route'
import { Route as AppAdminUsersUserIdRouteRouteImport } from './../../pages/_app/admin/users/$userId/route'
import { Route as AppUserManagementUsersRolesIndexRouteImport } from './../../pages/_app/user-management/users/roles/index'
import { Route as AppUserManagementUsersUserIdIndexRouteImport } from './../../pages/_app/user-management/users/$userId/index'
import { Route as AppSalesRepresentativesRepresentativeIdIndexRouteImport } from './../../pages/_app/sales/representatives/$representativeId/index'
import { Route as AppSalesOffersTemplatesIndexRouteImport } from './../../pages/_app/sales/offers/templates/index'
import { Route as AppSalesOffersOfferIdIndexRouteImport } from './../../pages/_app/sales/offers/$offerId/index'
import { Route as AppSalesLeadsLeadIdIndexRouteImport } from './../../pages/_app/sales/leads/$leadId/index'
import { Route as AppSalesExpedientsExpedientIdIndexRouteImport } from './../../pages/_app/sales/expedients/$expedientId/index'
import { Route as AppSalesClientsClientIdIndexRouteImport } from './../../pages/_app/sales/clients/$clientId/index'
import { Route as AppEngineeringSuppliersFunctionsIndexRouteImport } from './../../pages/_app/engineering/suppliers/functions/index'
import { Route as AppEngineeringSuppliersSupplierIdIndexRouteImport } from './../../pages/_app/engineering/suppliers/$supplierId/index'
import { Route as AppEngineeringServicesFunctionsIndexRouteImport } from './../../pages/_app/engineering/services/functions/index'
import { Route as AppEngineeringServicesServiceIdIndexRouteImport } from './../../pages/_app/engineering/services/$serviceId/index'
import { Route as AppEngineeringMaterialsFunctionsIndexRouteImport } from './../../pages/_app/engineering/materials/functions/index'
import { Route as AppEngineeringMaterialsMaterialIdIndexRouteImport } from './../../pages/_app/engineering/materials/$materialId/index'
import { Route as AppAdminUsersUserIdIndexRouteImport } from './../../pages/_app/admin/users/$userId/index'
import { Route as AppUserManagementUsersRolesRoleIdRouteRouteImport } from './../../pages/_app/user-management/users/roles/$roleId/route'
import { Route as AppSalesOffersTemplatesOfferTemplateIdRouteRouteImport } from './../../pages/_app/sales/offers/templates/$offerTemplateId/route'
import { Route as AppUserManagementUsersRolesRoleIdIndexRouteImport } from './../../pages/_app/user-management/users/roles/$roleId/index'
import { Route as AppUserManagementUsersUserIdRolesIndexRouteImport } from './../../pages/_app/user-management/users/$userId/roles/index'
import { Route as AppUserManagementUsersUserIdPermissionsIndexRouteImport } from './../../pages/_app/user-management/users/$userId/permissions/index'
import { Route as AppSalesRepresentativesRepresentativeIdNotesIndexRouteImport } from './../../pages/_app/sales/representatives/$representativeId/notes/index'
import { Route as AppSalesRepresentativesRepresentativeIdContactsIndexRouteImport } from './../../pages/_app/sales/representatives/$representativeId/contacts/index'
import { Route as AppSalesRepresentativesRepresentativeIdCommissionsIndexRouteImport } from './../../pages/_app/sales/representatives/$representativeId/commissions/index'
import { Route as AppSalesOffersTemplatesOfferTemplateIdIndexRouteImport } from './../../pages/_app/sales/offers/templates/$offerTemplateId/index'
import { Route as AppSalesOffersEditorCustomerOfferIdIndexRouteImport } from './../../pages/_app/sales/offers/editor/$customerOfferId/index'
import { Route as AppSalesOffersOfferIdPreviewIndexRouteImport } from './../../pages/_app/sales/offers/$offerId/preview/index'
import { Route as AppSalesOffersOfferIdNotesIndexRouteImport } from './../../pages/_app/sales/offers/$offerId/notes/index'
import { Route as AppSalesOffersOfferIdHistoryIndexRouteImport } from './../../pages/_app/sales/offers/$offerId/history/index'
import { Route as AppSalesOffersOfferIdEditorIndexRouteImport } from './../../pages/_app/sales/offers/$offerId/editor/index'
import { Route as AppSalesOffersOfferIdDetailsIndexRouteImport } from './../../pages/_app/sales/offers/$offerId/details/index'
import { Route as AppSalesLeadsLeadIdNotesIndexRouteImport } from './../../pages/_app/sales/leads/$leadId/notes/index'
import { Route as AppSalesLeadsLeadIdContactsIndexRouteImport } from './../../pages/_app/sales/leads/$leadId/contacts/index'
import { Route as AppSalesExpedientsExpedientIdOptionsIndexRouteImport } from './../../pages/_app/sales/expedients/$expedientId/options/index'
import { Route as AppSalesExpedientsExpedientIdOffersIndexRouteImport } from './../../pages/_app/sales/expedients/$expedientId/offers/index'
import { Route as AppSalesExpedientsExpedientIdNotesIndexRouteImport } from './../../pages/_app/sales/expedients/$expedientId/notes/index'
import { Route as AppSalesClientsClientIdNotesIndexRouteImport } from './../../pages/_app/sales/clients/$clientId/notes/index'
import { Route as AppSalesClientsClientIdContactsIndexRouteImport } from './../../pages/_app/sales/clients/$clientId/contacts/index'
import { Route as AppEngineeringSuppliersSupplierIdOffersIndexRouteImport } from './../../pages/_app/engineering/suppliers/$supplierId/offers/index'
import { Route as AppEngineeringSuppliersSupplierIdNotesIndexRouteImport } from './../../pages/_app/engineering/suppliers/$supplierId/notes/index'
import { Route as AppEngineeringSuppliersSupplierIdContactsIndexRouteImport } from './../../pages/_app/engineering/suppliers/$supplierId/contacts/index'
import { Route as AppEngineeringServicesServiceIdOffersIndexRouteImport } from './../../pages/_app/engineering/services/$serviceId/offers/index'
import { Route as AppEngineeringServicesServiceIdNotesIndexRouteImport } from './../../pages/_app/engineering/services/$serviceId/notes/index'
import { Route as AppEngineeringServicesServiceIdDescriptionsIndexRouteImport } from './../../pages/_app/engineering/services/$serviceId/descriptions/index'
import { Route as AppEngineeringServicesServiceIdCompositionIndexRouteImport } from './../../pages/_app/engineering/services/$serviceId/composition/index'
import { Route as AppEngineeringMaterialsMaterialIdOffersIndexRouteImport } from './../../pages/_app/engineering/materials/$materialId/offers/index'
import { Route as AppEngineeringMaterialsMaterialIdNotesIndexRouteImport } from './../../pages/_app/engineering/materials/$materialId/notes/index'
import { Route as AppEngineeringMaterialsMaterialIdDescriptionsIndexRouteImport } from './../../pages/_app/engineering/materials/$materialId/descriptions/index'
import { Route as AppEngineeringMaterialsMaterialIdCompositionIndexRouteImport } from './../../pages/_app/engineering/materials/$materialId/composition/index'
import { Route as AppAdminUsersUserIdTasksIndexRouteImport } from './../../pages/_app/admin/users/$userId/tasks/index'
import { Route as AppAdminUsersUserIdStatisticsIndexRouteImport } from './../../pages/_app/admin/users/$userId/statistics/index'
import { Route as AppUserManagementUsersRolesRoleIdPermissionsIndexRouteImport } from './../../pages/_app/user-management/users/roles/$roleId/permissions/index'
import { Route as AppSalesOffersTemplatesEditorOfferTemplateIdIndexRouteImport } from './../../pages/_app/sales/offers/templates/editor/$offerTemplateId/index'
import { Route as AppSalesOffersTemplatesOfferTemplateIdPreviewIndexRouteImport } from './../../pages/_app/sales/offers/templates/$offerTemplateId/preview/index'
import { Route as AppSalesOffersTemplatesOfferTemplateIdNotesIndexRouteImport } from './../../pages/_app/sales/offers/templates/$offerTemplateId/notes/index'
import { Route as AppSalesOffersTemplatesOfferTemplateIdEditorIndexRouteImport } from './../../pages/_app/sales/offers/templates/$offerTemplateId/editor/index'
import { Route as AppSalesOffersTemplatesOfferTemplateIdDetailsIndexRouteImport } from './../../pages/_app/sales/offers/templates/$offerTemplateId/details/index'

const SignedOutRoute = SignedOutRouteImport.update({
  id: '/signed-out',
  path: '/signed-out',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AccountNotLinkedRoute = AccountNotLinkedRouteImport.update({
  id: '/account-not-linked',
  path: '/account-not-linked',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDashboardIndexRoute = AppDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppUserManagementUsersRouteRoute =
  AppUserManagementUsersRouteRouteImport.update({
    id: '/user-management/users',
    path: '/user-management/users',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppSalesRepresentativesRouteRoute =
  AppSalesRepresentativesRouteRouteImport.update({
    id: '/sales/representatives',
    path: '/sales/representatives',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppSalesOffersRouteRoute = AppSalesOffersRouteRouteImport.update({
  id: '/sales/offers',
  path: '/sales/offers',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSalesOfferTemplatesRouteRoute =
  AppSalesOfferTemplatesRouteRouteImport.update({
    id: '/sales/offer-templates',
    path: '/sales/offer-templates',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppSalesLeadsRouteRoute = AppSalesLeadsRouteRouteImport.update({
  id: '/sales/leads',
  path: '/sales/leads',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSalesExpedientsRouteRoute = AppSalesExpedientsRouteRouteImport.update({
  id: '/sales/expedients',
  path: '/sales/expedients',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSalesClientsRouteRoute = AppSalesClientsRouteRouteImport.update({
  id: '/sales/clients',
  path: '/sales/clients',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppEngineeringSuppliersRouteRoute =
  AppEngineeringSuppliersRouteRouteImport.update({
    id: '/engineering/suppliers',
    path: '/engineering/suppliers',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppEngineeringServicesRouteRoute =
  AppEngineeringServicesRouteRouteImport.update({
    id: '/engineering/services',
    path: '/engineering/services',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppEngineeringMaterialsRouteRoute =
  AppEngineeringMaterialsRouteRouteImport.update({
    id: '/engineering/materials',
    path: '/engineering/materials',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppEngineeringMaterialFunctionsRouteRoute =
  AppEngineeringMaterialFunctionsRouteRouteImport.update({
    id: '/engineering/material-functions',
    path: '/engineering/material-functions',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppAdminUsersRouteRoute = AppAdminUsersRouteRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppUserManagementUsersIndexRoute =
  AppUserManagementUsersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppUserManagementUsersRouteRoute,
  } as any)
const AppSalesRepresentativesIndexRoute =
  AppSalesRepresentativesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSalesRepresentativesRouteRoute,
  } as any)
const AppSalesOffersIndexRoute = AppSalesOffersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSalesOffersRouteRoute,
} as any)
const AppSalesOfferTemplatesIndexRoute =
  AppSalesOfferTemplatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSalesOfferTemplatesRouteRoute,
  } as any)
const AppSalesLeadsIndexRoute = AppSalesLeadsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSalesLeadsRouteRoute,
} as any)
const AppSalesExpedientsIndexRoute = AppSalesExpedientsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSalesExpedientsRouteRoute,
} as any)
const AppSalesClientsIndexRoute = AppSalesClientsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSalesClientsRouteRoute,
} as any)
const AppEngineeringSuppliersIndexRoute =
  AppEngineeringSuppliersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppEngineeringSuppliersRouteRoute,
  } as any)
const AppEngineeringServicesIndexRoute =
  AppEngineeringServicesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppEngineeringServicesRouteRoute,
  } as any)
const AppEngineeringMaterialsIndexRoute =
  AppEngineeringMaterialsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppEngineeringMaterialsRouteRoute,
  } as any)
const AppEngineeringMaterialFunctionsIndexRoute =
  AppEngineeringMaterialFunctionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppEngineeringMaterialFunctionsRouteRoute,
  } as any)
const AppDiagramDiagramIdIndexRoute =
  AppDiagramDiagramIdIndexRouteImport.update({
    id: '/diagram/$diagramId/',
    path: '/diagram/$diagramId/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppDevDashboardIndexRoute = AppDevDashboardIndexRouteImport.update({
  id: '/dev/dashboard/',
  path: '/dev/dashboard/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminUsersIndexRoute = AppAdminUsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminUsersRouteRoute,
} as any)
const AppUserManagementUsersRolesRouteRoute =
  AppUserManagementUsersRolesRouteRouteImport.update({
    id: '/roles',
    path: '/roles',
    getParentRoute: () => AppUserManagementUsersRouteRoute,
  } as any)
const AppUserManagementUsersUserIdRouteRoute =
  AppUserManagementUsersUserIdRouteRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => AppUserManagementUsersRouteRoute,
  } as any)
const AppSalesRepresentativesRepresentativeIdRouteRoute =
  AppSalesRepresentativesRepresentativeIdRouteRouteImport.update({
    id: '/$representativeId',
    path: '/$representativeId',
    getParentRoute: () => AppSalesRepresentativesRouteRoute,
  } as any)
const AppSalesOffersTemplatesRouteRoute =
  AppSalesOffersTemplatesRouteRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => AppSalesOffersRouteRoute,
  } as any)
const AppSalesOffersOfferIdRouteRoute =
  AppSalesOffersOfferIdRouteRouteImport.update({
    id: '/$offerId',
    path: '/$offerId',
    getParentRoute: () => AppSalesOffersRouteRoute,
  } as any)
const AppSalesLeadsLeadIdRouteRoute =
  AppSalesLeadsLeadIdRouteRouteImport.update({
    id: '/$leadId',
    path: '/$leadId',
    getParentRoute: () => AppSalesLeadsRouteRoute,
  } as any)
const AppSalesExpedientsExpedientIdRouteRoute =
  AppSalesExpedientsExpedientIdRouteRouteImport.update({
    id: '/$expedientId',
    path: '/$expedientId',
    getParentRoute: () => AppSalesExpedientsRouteRoute,
  } as any)
const AppSalesClientsClientIdRouteRoute =
  AppSalesClientsClientIdRouteRouteImport.update({
    id: '/$clientId',
    path: '/$clientId',
    getParentRoute: () => AppSalesClientsRouteRoute,
  } as any)
const AppEngineeringSuppliersFunctionsRouteRoute =
  AppEngineeringSuppliersFunctionsRouteRouteImport.update({
    id: '/functions',
    path: '/functions',
    getParentRoute: () => AppEngineeringSuppliersRouteRoute,
  } as any)
const AppEngineeringSuppliersSupplierIdRouteRoute =
  AppEngineeringSuppliersSupplierIdRouteRouteImport.update({
    id: '/$supplierId',
    path: '/$supplierId',
    getParentRoute: () => AppEngineeringSuppliersRouteRoute,
  } as any)
const AppEngineeringServicesFunctionsRouteRoute =
  AppEngineeringServicesFunctionsRouteRouteImport.update({
    id: '/functions',
    path: '/functions',
    getParentRoute: () => AppEngineeringServicesRouteRoute,
  } as any)
const AppEngineeringServicesServiceIdRouteRoute =
  AppEngineeringServicesServiceIdRouteRouteImport.update({
    id: '/$serviceId',
    path: '/$serviceId',
    getParentRoute: () => AppEngineeringServicesRouteRoute,
  } as any)
const AppEngineeringMaterialsFunctionsRouteRoute =
  AppEngineeringMaterialsFunctionsRouteRouteImport.update({
    id: '/functions',
    path: '/functions',
    getParentRoute: () => AppEngineeringMaterialsRouteRoute,
  } as any)
const AppEngineeringMaterialsMaterialIdRouteRoute =
  AppEngineeringMaterialsMaterialIdRouteRouteImport.update({
    id: '/$materialId',
    path: '/$materialId',
    getParentRoute: () => AppEngineeringMaterialsRouteRoute,
  } as any)
const AppAdminUsersUserIdRouteRoute =
  AppAdminUsersUserIdRouteRouteImport.update({
    id: '/$userId',
    path: '/$userId',
    getParentRoute: () => AppAdminUsersRouteRoute,
  } as any)
const AppUserManagementUsersRolesIndexRoute =
  AppUserManagementUsersRolesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppUserManagementUsersRolesRouteRoute,
  } as any)
const AppUserManagementUsersUserIdIndexRoute =
  AppUserManagementUsersUserIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppUserManagementUsersUserIdRouteRoute,
  } as any)
const AppSalesRepresentativesRepresentativeIdIndexRoute =
  AppSalesRepresentativesRepresentativeIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSalesRepresentativesRepresentativeIdRouteRoute,
  } as any)
const AppSalesOffersTemplatesIndexRoute =
  AppSalesOffersTemplatesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSalesOffersTemplatesRouteRoute,
  } as any)
const AppSalesOffersOfferIdIndexRoute =
  AppSalesOffersOfferIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSalesOffersOfferIdRouteRoute,
  } as any)
const AppSalesLeadsLeadIdIndexRoute =
  AppSalesLeadsLeadIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSalesLeadsLeadIdRouteRoute,
  } as any)
const AppSalesExpedientsExpedientIdIndexRoute =
  AppSalesExpedientsExpedientIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSalesExpedientsExpedientIdRouteRoute,
  } as any)
const AppSalesClientsClientIdIndexRoute =
  AppSalesClientsClientIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSalesClientsClientIdRouteRoute,
  } as any)
const AppEngineeringSuppliersFunctionsIndexRoute =
  AppEngineeringSuppliersFunctionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppEngineeringSuppliersFunctionsRouteRoute,
  } as any)
const AppEngineeringSuppliersSupplierIdIndexRoute =
  AppEngineeringSuppliersSupplierIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppEngineeringSuppliersSupplierIdRouteRoute,
  } as any)
const AppEngineeringServicesFunctionsIndexRoute =
  AppEngineeringServicesFunctionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppEngineeringServicesFunctionsRouteRoute,
  } as any)
const AppEngineeringServicesServiceIdIndexRoute =
  AppEngineeringServicesServiceIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppEngineeringServicesServiceIdRouteRoute,
  } as any)
const AppEngineeringMaterialsFunctionsIndexRoute =
  AppEngineeringMaterialsFunctionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppEngineeringMaterialsFunctionsRouteRoute,
  } as any)
const AppEngineeringMaterialsMaterialIdIndexRoute =
  AppEngineeringMaterialsMaterialIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppEngineeringMaterialsMaterialIdRouteRoute,
  } as any)
const AppAdminUsersUserIdIndexRoute =
  AppAdminUsersUserIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminUsersUserIdRouteRoute,
  } as any)
const AppUserManagementUsersRolesRoleIdRouteRoute =
  AppUserManagementUsersRolesRoleIdRouteRouteImport.update({
    id: '/$roleId',
    path: '/$roleId',
    getParentRoute: () => AppUserManagementUsersRolesRouteRoute,
  } as any)
const AppSalesOffersTemplatesOfferTemplateIdRouteRoute =
  AppSalesOffersTemplatesOfferTemplateIdRouteRouteImport.update({
    id: '/$offerTemplateId',
    path: '/$offerTemplateId',
    getParentRoute: () => AppSalesOffersTemplatesRouteRoute,
  } as any)
const AppUserManagementUsersRolesRoleIdIndexRoute =
  AppUserManagementUsersRolesRoleIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppUserManagementUsersRolesRoleIdRouteRoute,
  } as any)
const AppUserManagementUsersUserIdRolesIndexRoute =
  AppUserManagementUsersUserIdRolesIndexRouteImport.update({
    id: '/roles/',
    path: '/roles/',
    getParentRoute: () => AppUserManagementUsersUserIdRouteRoute,
  } as any)
const AppUserManagementUsersUserIdPermissionsIndexRoute =
  AppUserManagementUsersUserIdPermissionsIndexRouteImport.update({
    id: '/permissions/',
    path: '/permissions/',
    getParentRoute: () => AppUserManagementUsersUserIdRouteRoute,
  } as any)
const AppSalesRepresentativesRepresentativeIdNotesIndexRoute =
  AppSalesRepresentativesRepresentativeIdNotesIndexRouteImport.update({
    id: '/notes/',
    path: '/notes/',
    getParentRoute: () => AppSalesRepresentativesRepresentativeIdRouteRoute,
  } as any)
const AppSalesRepresentativesRepresentativeIdContactsIndexRoute =
  AppSalesRepresentativesRepresentativeIdContactsIndexRouteImport.update({
    id: '/contacts/',
    path: '/contacts/',
    getParentRoute: () => AppSalesRepresentativesRepresentativeIdRouteRoute,
  } as any)
const AppSalesRepresentativesRepresentativeIdCommissionsIndexRoute =
  AppSalesRepresentativesRepresentativeIdCommissionsIndexRouteImport.update({
    id: '/commissions/',
    path: '/commissions/',
    getParentRoute: () => AppSalesRepresentativesRepresentativeIdRouteRoute,
  } as any)
const AppSalesOffersTemplatesOfferTemplateIdIndexRoute =
  AppSalesOffersTemplatesOfferTemplateIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSalesOffersTemplatesOfferTemplateIdRouteRoute,
  } as any)
const AppSalesOffersEditorCustomerOfferIdIndexRoute =
  AppSalesOffersEditorCustomerOfferIdIndexRouteImport.update({
    id: '/editor/$customerOfferId/',
    path: '/editor/$customerOfferId/',
    getParentRoute: () => AppSalesOffersRouteRoute,
  } as any)
const AppSalesOffersOfferIdPreviewIndexRoute =
  AppSalesOffersOfferIdPreviewIndexRouteImport.update({
    id: '/preview/',
    path: '/preview/',
    getParentRoute: () => AppSalesOffersOfferIdRouteRoute,
  } as any)
const AppSalesOffersOfferIdNotesIndexRoute =
  AppSalesOffersOfferIdNotesIndexRouteImport.update({
    id: '/notes/',
    path: '/notes/',
    getParentRoute: () => AppSalesOffersOfferIdRouteRoute,
  } as any)
const AppSalesOffersOfferIdHistoryIndexRoute =
  AppSalesOffersOfferIdHistoryIndexRouteImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => AppSalesOffersOfferIdRouteRoute,
  } as any)
const AppSalesOffersOfferIdEditorIndexRoute =
  AppSalesOffersOfferIdEditorIndexRouteImport.update({
    id: '/editor/',
    path: '/editor/',
    getParentRoute: () => AppSalesOffersOfferIdRouteRoute,
  } as any)
const AppSalesOffersOfferIdDetailsIndexRoute =
  AppSalesOffersOfferIdDetailsIndexRouteImport.update({
    id: '/details/',
    path: '/details/',
    getParentRoute: () => AppSalesOffersOfferIdRouteRoute,
  } as any)
const AppSalesLeadsLeadIdNotesIndexRoute =
  AppSalesLeadsLeadIdNotesIndexRouteImport.update({
    id: '/notes/',
    path: '/notes/',
    getParentRoute: () => AppSalesLeadsLeadIdRouteRoute,
  } as any)
const AppSalesLeadsLeadIdContactsIndexRoute =
  AppSalesLeadsLeadIdContactsIndexRouteImport.update({
    id: '/contacts/',
    path: '/contacts/',
    getParentRoute: () => AppSalesLeadsLeadIdRouteRoute,
  } as any)
const AppSalesExpedientsExpedientIdOptionsIndexRoute =
  AppSalesExpedientsExpedientIdOptionsIndexRouteImport.update({
    id: '/options/',
    path: '/options/',
    getParentRoute: () => AppSalesExpedientsExpedientIdRouteRoute,
  } as any)
const AppSalesExpedientsExpedientIdOffersIndexRoute =
  AppSalesExpedientsExpedientIdOffersIndexRouteImport.update({
    id: '/offers/',
    path: '/offers/',
    getParentRoute: () => AppSalesExpedientsExpedientIdRouteRoute,
  } as any)
const AppSalesExpedientsExpedientIdNotesIndexRoute =
  AppSalesExpedientsExpedientIdNotesIndexRouteImport.update({
    id: '/notes/',
    path: '/notes/',
    getParentRoute: () => AppSalesExpedientsExpedientIdRouteRoute,
  } as any)
const AppSalesClientsClientIdNotesIndexRoute =
  AppSalesClientsClientIdNotesIndexRouteImport.update({
    id: '/notes/',
    path: '/notes/',
    getParentRoute: () => AppSalesClientsClientIdRouteRoute,
  } as any)
const AppSalesClientsClientIdContactsIndexRoute =
  AppSalesClientsClientIdContactsIndexRouteImport.update({
    id: '/contacts/',
    path: '/contacts/',
    getParentRoute: () => AppSalesClientsClientIdRouteRoute,
  } as any)
const AppEngineeringSuppliersSupplierIdOffersIndexRoute =
  AppEngineeringSuppliersSupplierIdOffersIndexRouteImport.update({
    id: '/offers/',
    path: '/offers/',
    getParentRoute: () => AppEngineeringSuppliersSupplierIdRouteRoute,
  } as any)
const AppEngineeringSuppliersSupplierIdNotesIndexRoute =
  AppEngineeringSuppliersSupplierIdNotesIndexRouteImport.update({
    id: '/notes/',
    path: '/notes/',
    getParentRoute: () => AppEngineeringSuppliersSupplierIdRouteRoute,
  } as any)
const AppEngineeringSuppliersSupplierIdContactsIndexRoute =
  AppEngineeringSuppliersSupplierIdContactsIndexRouteImport.update({
    id: '/contacts/',
    path: '/contacts/',
    getParentRoute: () => AppEngineeringSuppliersSupplierIdRouteRoute,
  } as any)
const AppEngineeringServicesServiceIdOffersIndexRoute =
  AppEngineeringServicesServiceIdOffersIndexRouteImport.update({
    id: '/offers/',
    path: '/offers/',
    getParentRoute: () => AppEngineeringServicesServiceIdRouteRoute,
  } as any)
const AppEngineeringServicesServiceIdNotesIndexRoute =
  AppEngineeringServicesServiceIdNotesIndexRouteImport.update({
    id: '/notes/',
    path: '/notes/',
    getParentRoute: () => AppEngineeringServicesServiceIdRouteRoute,
  } as any)
const AppEngineeringServicesServiceIdDescriptionsIndexRoute =
  AppEngineeringServicesServiceIdDescriptionsIndexRouteImport.update({
    id: '/descriptions/',
    path: '/descriptions/',
    getParentRoute: () => AppEngineeringServicesServiceIdRouteRoute,
  } as any)
const AppEngineeringServicesServiceIdCompositionIndexRoute =
  AppEngineeringServicesServiceIdCompositionIndexRouteImport.update({
    id: '/composition/',
    path: '/composition/',
    getParentRoute: () => AppEngineeringServicesServiceIdRouteRoute,
  } as any)
const AppEngineeringMaterialsMaterialIdOffersIndexRoute =
  AppEngineeringMaterialsMaterialIdOffersIndexRouteImport.update({
    id: '/offers/',
    path: '/offers/',
    getParentRoute: () => AppEngineeringMaterialsMaterialIdRouteRoute,
  } as any)
const AppEngineeringMaterialsMaterialIdNotesIndexRoute =
  AppEngineeringMaterialsMaterialIdNotesIndexRouteImport.update({
    id: '/notes/',
    path: '/notes/',
    getParentRoute: () => AppEngineeringMaterialsMaterialIdRouteRoute,
  } as any)
const AppEngineeringMaterialsMaterialIdDescriptionsIndexRoute =
  AppEngineeringMaterialsMaterialIdDescriptionsIndexRouteImport.update({
    id: '/descriptions/',
    path: '/descriptions/',
    getParentRoute: () => AppEngineeringMaterialsMaterialIdRouteRoute,
  } as any)
const AppEngineeringMaterialsMaterialIdCompositionIndexRoute =
  AppEngineeringMaterialsMaterialIdCompositionIndexRouteImport.update({
    id: '/composition/',
    path: '/composition/',
    getParentRoute: () => AppEngineeringMaterialsMaterialIdRouteRoute,
  } as any)
const AppAdminUsersUserIdTasksIndexRoute =
  AppAdminUsersUserIdTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => AppAdminUsersUserIdRouteRoute,
  } as any)
const AppAdminUsersUserIdStatisticsIndexRoute =
  AppAdminUsersUserIdStatisticsIndexRouteImport.update({
    id: '/statistics/',
    path: '/statistics/',
    getParentRoute: () => AppAdminUsersUserIdRouteRoute,
  } as any)
const AppUserManagementUsersRolesRoleIdPermissionsIndexRoute =
  AppUserManagementUsersRolesRoleIdPermissionsIndexRouteImport.update({
    id: '/permissions/',
    path: '/permissions/',
    getParentRoute: () => AppUserManagementUsersRolesRoleIdRouteRoute,
  } as any)
const AppSalesOffersTemplatesEditorOfferTemplateIdIndexRoute =
  AppSalesOffersTemplatesEditorOfferTemplateIdIndexRouteImport.update({
    id: '/editor/$offerTemplateId/',
    path: '/editor/$offerTemplateId/',
    getParentRoute: () => AppSalesOffersTemplatesRouteRoute,
  } as any)
const AppSalesOffersTemplatesOfferTemplateIdPreviewIndexRoute =
  AppSalesOffersTemplatesOfferTemplateIdPreviewIndexRouteImport.update({
    id: '/preview/',
    path: '/preview/',
    getParentRoute: () => AppSalesOffersTemplatesOfferTemplateIdRouteRoute,
  } as any)
const AppSalesOffersTemplatesOfferTemplateIdNotesIndexRoute =
  AppSalesOffersTemplatesOfferTemplateIdNotesIndexRouteImport.update({
    id: '/notes/',
    path: '/notes/',
    getParentRoute: () => AppSalesOffersTemplatesOfferTemplateIdRouteRoute,
  } as any)
const AppSalesOffersTemplatesOfferTemplateIdEditorIndexRoute =
  AppSalesOffersTemplatesOfferTemplateIdEditorIndexRouteImport.update({
    id: '/editor/',
    path: '/editor/',
    getParentRoute: () => AppSalesOffersTemplatesOfferTemplateIdRouteRoute,
  } as any)
const AppSalesOffersTemplatesOfferTemplateIdDetailsIndexRoute =
  AppSalesOffersTemplatesOfferTemplateIdDetailsIndexRouteImport.update({
    id: '/details/',
    path: '/details/',
    getParentRoute: () => AppSalesOffersTemplatesOfferTemplateIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/account-not-linked': typeof AccountNotLinkedRoute
  '/login': typeof LoginRoute
  '/signed-out': typeof SignedOutRoute
  '/admin/users': typeof AppAdminUsersRouteRouteWithChildren
  '/engineering/material-functions': typeof AppEngineeringMaterialFunctionsRouteRouteWithChildren
  '/engineering/materials': typeof AppEngineeringMaterialsRouteRouteWithChildren
  '/engineering/services': typeof AppEngineeringServicesRouteRouteWithChildren
  '/engineering/suppliers': typeof AppEngineeringSuppliersRouteRouteWithChildren
  '/sales/clients': typeof AppSalesClientsRouteRouteWithChildren
  '/sales/expedients': typeof AppSalesExpedientsRouteRouteWithChildren
  '/sales/leads': typeof AppSalesLeadsRouteRouteWithChildren
  '/sales/offer-templates': typeof AppSalesOfferTemplatesRouteRouteWithChildren
  '/sales/offers': typeof AppSalesOffersRouteRouteWithChildren
  '/sales/representatives': typeof AppSalesRepresentativesRouteRouteWithChildren
  '/user-management/users': typeof AppUserManagementUsersRouteRouteWithChildren
  '/dashboard/': typeof AppDashboardIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/admin/users/$userId': typeof AppAdminUsersUserIdRouteRouteWithChildren
  '/engineering/materials/$materialId': typeof AppEngineeringMaterialsMaterialIdRouteRouteWithChildren
  '/engineering/materials/functions': typeof AppEngineeringMaterialsFunctionsRouteRouteWithChildren
  '/engineering/services/$serviceId': typeof AppEngineeringServicesServiceIdRouteRouteWithChildren
  '/engineering/services/functions': typeof AppEngineeringServicesFunctionsRouteRouteWithChildren
  '/engineering/suppliers/$supplierId': typeof AppEngineeringSuppliersSupplierIdRouteRouteWithChildren
  '/engineering/suppliers/functions': typeof AppEngineeringSuppliersFunctionsRouteRouteWithChildren
  '/sales/clients/$clientId': typeof AppSalesClientsClientIdRouteRouteWithChildren
  '/sales/expedients/$expedientId': typeof AppSalesExpedientsExpedientIdRouteRouteWithChildren
  '/sales/leads/$leadId': typeof AppSalesLeadsLeadIdRouteRouteWithChildren
  '/sales/offers/$offerId': typeof AppSalesOffersOfferIdRouteRouteWithChildren
  '/sales/offers/templates': typeof AppSalesOffersTemplatesRouteRouteWithChildren
  '/sales/representatives/$representativeId': typeof AppSalesRepresentativesRepresentativeIdRouteRouteWithChildren
  '/user-management/users/$userId': typeof AppUserManagementUsersUserIdRouteRouteWithChildren
  '/user-management/users/roles': typeof AppUserManagementUsersRolesRouteRouteWithChildren
  '/admin/users/': typeof AppAdminUsersIndexRoute
  '/dev/dashboard/': typeof AppDevDashboardIndexRoute
  '/diagram/$diagramId/': typeof AppDiagramDiagramIdIndexRoute
  '/engineering/material-functions/': typeof AppEngineeringMaterialFunctionsIndexRoute
  '/engineering/materials/': typeof AppEngineeringMaterialsIndexRoute
  '/engineering/services/': typeof AppEngineeringServicesIndexRoute
  '/engineering/suppliers/': typeof AppEngineeringSuppliersIndexRoute
  '/sales/clients/': typeof AppSalesClientsIndexRoute
  '/sales/expedients/': typeof AppSalesExpedientsIndexRoute
  '/sales/leads/': typeof AppSalesLeadsIndexRoute
  '/sales/offer-templates/': typeof AppSalesOfferTemplatesIndexRoute
  '/sales/offers/': typeof AppSalesOffersIndexRoute
  '/sales/representatives/': typeof AppSalesRepresentativesIndexRoute
  '/user-management/users/': typeof AppUserManagementUsersIndexRoute
  '/sales/offers/templates/$offerTemplateId': typeof AppSalesOffersTemplatesOfferTemplateIdRouteRouteWithChildren
  '/user-management/users/roles/$roleId': typeof AppUserManagementUsersRolesRoleIdRouteRouteWithChildren
  '/admin/users/$userId/': typeof AppAdminUsersUserIdIndexRoute
  '/engineering/materials/$materialId/': typeof AppEngineeringMaterialsMaterialIdIndexRoute
  '/engineering/materials/functions/': typeof AppEngineeringMaterialsFunctionsIndexRoute
  '/engineering/services/$serviceId/': typeof AppEngineeringServicesServiceIdIndexRoute
  '/engineering/services/functions/': typeof AppEngineeringServicesFunctionsIndexRoute
  '/engineering/suppliers/$supplierId/': typeof AppEngineeringSuppliersSupplierIdIndexRoute
  '/engineering/suppliers/functions/': typeof AppEngineeringSuppliersFunctionsIndexRoute
  '/sales/clients/$clientId/': typeof AppSalesClientsClientIdIndexRoute
  '/sales/expedients/$expedientId/': typeof AppSalesExpedientsExpedientIdIndexRoute
  '/sales/leads/$leadId/': typeof AppSalesLeadsLeadIdIndexRoute
  '/sales/offers/$offerId/': typeof AppSalesOffersOfferIdIndexRoute
  '/sales/offers/templates/': typeof AppSalesOffersTemplatesIndexRoute
  '/sales/representatives/$representativeId/': typeof AppSalesRepresentativesRepresentativeIdIndexRoute
  '/user-management/users/$userId/': typeof AppUserManagementUsersUserIdIndexRoute
  '/user-management/users/roles/': typeof AppUserManagementUsersRolesIndexRoute
  '/admin/users/$userId/statistics/': typeof AppAdminUsersUserIdStatisticsIndexRoute
  '/admin/users/$userId/tasks/': typeof AppAdminUsersUserIdTasksIndexRoute
  '/engineering/materials/$materialId/composition/': typeof AppEngineeringMaterialsMaterialIdCompositionIndexRoute
  '/engineering/materials/$materialId/descriptions/': typeof AppEngineeringMaterialsMaterialIdDescriptionsIndexRoute
  '/engineering/materials/$materialId/notes/': typeof AppEngineeringMaterialsMaterialIdNotesIndexRoute
  '/engineering/materials/$materialId/offers/': typeof AppEngineeringMaterialsMaterialIdOffersIndexRoute
  '/engineering/services/$serviceId/composition/': typeof AppEngineeringServicesServiceIdCompositionIndexRoute
  '/engineering/services/$serviceId/descriptions/': typeof AppEngineeringServicesServiceIdDescriptionsIndexRoute
  '/engineering/services/$serviceId/notes/': typeof AppEngineeringServicesServiceIdNotesIndexRoute
  '/engineering/services/$serviceId/offers/': typeof AppEngineeringServicesServiceIdOffersIndexRoute
  '/engineering/suppliers/$supplierId/contacts/': typeof AppEngineeringSuppliersSupplierIdContactsIndexRoute
  '/engineering/suppliers/$supplierId/notes/': typeof AppEngineeringSuppliersSupplierIdNotesIndexRoute
  '/engineering/suppliers/$supplierId/offers/': typeof AppEngineeringSuppliersSupplierIdOffersIndexRoute
  '/sales/clients/$clientId/contacts/': typeof AppSalesClientsClientIdContactsIndexRoute
  '/sales/clients/$clientId/notes/': typeof AppSalesClientsClientIdNotesIndexRoute
  '/sales/expedients/$expedientId/notes/': typeof AppSalesExpedientsExpedientIdNotesIndexRoute
  '/sales/expedients/$expedientId/offers/': typeof AppSalesExpedientsExpedientIdOffersIndexRoute
  '/sales/expedients/$expedientId/options/': typeof AppSalesExpedientsExpedientIdOptionsIndexRoute
  '/sales/leads/$leadId/contacts/': typeof AppSalesLeadsLeadIdContactsIndexRoute
  '/sales/leads/$leadId/notes/': typeof AppSalesLeadsLeadIdNotesIndexRoute
  '/sales/offers/$offerId/details/': typeof AppSalesOffersOfferIdDetailsIndexRoute
  '/sales/offers/$offerId/editor/': typeof AppSalesOffersOfferIdEditorIndexRoute
  '/sales/offers/$offerId/history/': typeof AppSalesOffersOfferIdHistoryIndexRoute
  '/sales/offers/$offerId/notes/': typeof AppSalesOffersOfferIdNotesIndexRoute
  '/sales/offers/$offerId/preview/': typeof AppSalesOffersOfferIdPreviewIndexRoute
  '/sales/offers/editor/$customerOfferId/': typeof AppSalesOffersEditorCustomerOfferIdIndexRoute
  '/sales/offers/templates/$offerTemplateId/': typeof AppSalesOffersTemplatesOfferTemplateIdIndexRoute
  '/sales/representatives/$representativeId/commissions/': typeof AppSalesRepresentativesRepresentativeIdCommissionsIndexRoute
  '/sales/representatives/$representativeId/contacts/': typeof AppSalesRepresentativesRepresentativeIdContactsIndexRoute
  '/sales/representatives/$representativeId/notes/': typeof AppSalesRepresentativesRepresentativeIdNotesIndexRoute
  '/user-management/users/$userId/permissions/': typeof AppUserManagementUsersUserIdPermissionsIndexRoute
  '/user-management/users/$userId/roles/': typeof AppUserManagementUsersUserIdRolesIndexRoute
  '/user-management/users/roles/$roleId/': typeof AppUserManagementUsersRolesRoleIdIndexRoute
  '/sales/offers/templates/$offerTemplateId/details/': typeof AppSalesOffersTemplatesOfferTemplateIdDetailsIndexRoute
  '/sales/offers/templates/$offerTemplateId/editor/': typeof AppSalesOffersTemplatesOfferTemplateIdEditorIndexRoute
  '/sales/offers/templates/$offerTemplateId/notes/': typeof AppSalesOffersTemplatesOfferTemplateIdNotesIndexRoute
  '/sales/offers/templates/$offerTemplateId/preview/': typeof AppSalesOffersTemplatesOfferTemplateIdPreviewIndexRoute
  '/sales/offers/templates/editor/$offerTemplateId/': typeof AppSalesOffersTemplatesEditorOfferTemplateIdIndexRoute
  '/user-management/users/roles/$roleId/permissions/': typeof AppUserManagementUsersRolesRoleIdPermissionsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/account-not-linked': typeof AccountNotLinkedRoute
  '/login': typeof LoginRoute
  '/signed-out': typeof SignedOutRoute
  '/dashboard': typeof AppDashboardIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/admin/users': typeof AppAdminUsersIndexRoute
  '/dev/dashboard': typeof AppDevDashboardIndexRoute
  '/diagram/$diagramId': typeof AppDiagramDiagramIdIndexRoute
  '/engineering/material-functions': typeof AppEngineeringMaterialFunctionsIndexRoute
  '/engineering/materials': typeof AppEngineeringMaterialsIndexRoute
  '/engineering/services': typeof AppEngineeringServicesIndexRoute
  '/engineering/suppliers': typeof AppEngineeringSuppliersIndexRoute
  '/sales/clients': typeof AppSalesClientsIndexRoute
  '/sales/expedients': typeof AppSalesExpedientsIndexRoute
  '/sales/leads': typeof AppSalesLeadsIndexRoute
  '/sales/offer-templates': typeof AppSalesOfferTemplatesIndexRoute
  '/sales/offers': typeof AppSalesOffersIndexRoute
  '/sales/representatives': typeof AppSalesRepresentativesIndexRoute
  '/user-management/users': typeof AppUserManagementUsersIndexRoute
  '/admin/users/$userId': typeof AppAdminUsersUserIdIndexRoute
  '/engineering/materials/$materialId': typeof AppEngineeringMaterialsMaterialIdIndexRoute
  '/engineering/materials/functions': typeof AppEngineeringMaterialsFunctionsIndexRoute
  '/engineering/services/$serviceId': typeof AppEngineeringServicesServiceIdIndexRoute
  '/engineering/services/functions': typeof AppEngineeringServicesFunctionsIndexRoute
  '/engineering/suppliers/$supplierId': typeof AppEngineeringSuppliersSupplierIdIndexRoute
  '/engineering/suppliers/functions': typeof AppEngineeringSuppliersFunctionsIndexRoute
  '/sales/clients/$clientId': typeof AppSalesClientsClientIdIndexRoute
  '/sales/expedients/$expedientId': typeof AppSalesExpedientsExpedientIdIndexRoute
  '/sales/leads/$leadId': typeof AppSalesLeadsLeadIdIndexRoute
  '/sales/offers/$offerId': typeof AppSalesOffersOfferIdIndexRoute
  '/sales/offers/templates': typeof AppSalesOffersTemplatesIndexRoute
  '/sales/representatives/$representativeId': typeof AppSalesRepresentativesRepresentativeIdIndexRoute
  '/user-management/users/$userId': typeof AppUserManagementUsersUserIdIndexRoute
  '/user-management/users/roles': typeof AppUserManagementUsersRolesIndexRoute
  '/admin/users/$userId/statistics': typeof AppAdminUsersUserIdStatisticsIndexRoute
  '/admin/users/$userId/tasks': typeof AppAdminUsersUserIdTasksIndexRoute
  '/engineering/materials/$materialId/composition': typeof AppEngineeringMaterialsMaterialIdCompositionIndexRoute
  '/engineering/materials/$materialId/descriptions': typeof AppEngineeringMaterialsMaterialIdDescriptionsIndexRoute
  '/engineering/materials/$materialId/notes': typeof AppEngineeringMaterialsMaterialIdNotesIndexRoute
  '/engineering/materials/$materialId/offers': typeof AppEngineeringMaterialsMaterialIdOffersIndexRoute
  '/engineering/services/$serviceId/composition': typeof AppEngineeringServicesServiceIdCompositionIndexRoute
  '/engineering/services/$serviceId/descriptions': typeof AppEngineeringServicesServiceIdDescriptionsIndexRoute
  '/engineering/services/$serviceId/notes': typeof AppEngineeringServicesServiceIdNotesIndexRoute
  '/engineering/services/$serviceId/offers': typeof AppEngineeringServicesServiceIdOffersIndexRoute
  '/engineering/suppliers/$supplierId/contacts': typeof AppEngineeringSuppliersSupplierIdContactsIndexRoute
  '/engineering/suppliers/$supplierId/notes': typeof AppEngineeringSuppliersSupplierIdNotesIndexRoute
  '/engineering/suppliers/$supplierId/offers': typeof AppEngineeringSuppliersSupplierIdOffersIndexRoute
  '/sales/clients/$clientId/contacts': typeof AppSalesClientsClientIdContactsIndexRoute
  '/sales/clients/$clientId/notes': typeof AppSalesClientsClientIdNotesIndexRoute
  '/sales/expedients/$expedientId/notes': typeof AppSalesExpedientsExpedientIdNotesIndexRoute
  '/sales/expedients/$expedientId/offers': typeof AppSalesExpedientsExpedientIdOffersIndexRoute
  '/sales/expedients/$expedientId/options': typeof AppSalesExpedientsExpedientIdOptionsIndexRoute
  '/sales/leads/$leadId/contacts': typeof AppSalesLeadsLeadIdContactsIndexRoute
  '/sales/leads/$leadId/notes': typeof AppSalesLeadsLeadIdNotesIndexRoute
  '/sales/offers/$offerId/details': typeof AppSalesOffersOfferIdDetailsIndexRoute
  '/sales/offers/$offerId/editor': typeof AppSalesOffersOfferIdEditorIndexRoute
  '/sales/offers/$offerId/history': typeof AppSalesOffersOfferIdHistoryIndexRoute
  '/sales/offers/$offerId/notes': typeof AppSalesOffersOfferIdNotesIndexRoute
  '/sales/offers/$offerId/preview': typeof AppSalesOffersOfferIdPreviewIndexRoute
  '/sales/offers/editor/$customerOfferId': typeof AppSalesOffersEditorCustomerOfferIdIndexRoute
  '/sales/offers/templates/$offerTemplateId': typeof AppSalesOffersTemplatesOfferTemplateIdIndexRoute
  '/sales/representatives/$representativeId/commissions': typeof AppSalesRepresentativesRepresentativeIdCommissionsIndexRoute
  '/sales/representatives/$representativeId/contacts': typeof AppSalesRepresentativesRepresentativeIdContactsIndexRoute
  '/sales/representatives/$representativeId/notes': typeof AppSalesRepresentativesRepresentativeIdNotesIndexRoute
  '/user-management/users/$userId/permissions': typeof AppUserManagementUsersUserIdPermissionsIndexRoute
  '/user-management/users/$userId/roles': typeof AppUserManagementUsersUserIdRolesIndexRoute
  '/user-management/users/roles/$roleId': typeof AppUserManagementUsersRolesRoleIdIndexRoute
  '/sales/offers/templates/$offerTemplateId/details': typeof AppSalesOffersTemplatesOfferTemplateIdDetailsIndexRoute
  '/sales/offers/templates/$offerTemplateId/editor': typeof AppSalesOffersTemplatesOfferTemplateIdEditorIndexRoute
  '/sales/offers/templates/$offerTemplateId/notes': typeof AppSalesOffersTemplatesOfferTemplateIdNotesIndexRoute
  '/sales/offers/templates/$offerTemplateId/preview': typeof AppSalesOffersTemplatesOfferTemplateIdPreviewIndexRoute
  '/sales/offers/templates/editor/$offerTemplateId': typeof AppSalesOffersTemplatesEditorOfferTemplateIdIndexRoute
  '/user-management/users/roles/$roleId/permissions': typeof AppUserManagementUsersRolesRoleIdPermissionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteRouteWithChildren
  '/account-not-linked': typeof AccountNotLinkedRoute
  '/login': typeof LoginRoute
  '/signed-out': typeof SignedOutRoute
  '/_app/admin/users': typeof AppAdminUsersRouteRouteWithChildren
  '/_app/engineering/material-functions': typeof AppEngineeringMaterialFunctionsRouteRouteWithChildren
  '/_app/engineering/materials': typeof AppEngineeringMaterialsRouteRouteWithChildren
  '/_app/engineering/services': typeof AppEngineeringServicesRouteRouteWithChildren
  '/_app/engineering/suppliers': typeof AppEngineeringSuppliersRouteRouteWithChildren
  '/_app/sales/clients': typeof AppSalesClientsRouteRouteWithChildren
  '/_app/sales/expedients': typeof AppSalesExpedientsRouteRouteWithChildren
  '/_app/sales/leads': typeof AppSalesLeadsRouteRouteWithChildren
  '/_app/sales/offer-templates': typeof AppSalesOfferTemplatesRouteRouteWithChildren
  '/_app/sales/offers': typeof AppSalesOffersRouteRouteWithChildren
  '/_app/sales/representatives': typeof AppSalesRepresentativesRouteRouteWithChildren
  '/_app/user-management/users': typeof AppUserManagementUsersRouteRouteWithChildren
  '/_app/dashboard/': typeof AppDashboardIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/admin/users/$userId': typeof AppAdminUsersUserIdRouteRouteWithChildren
  '/_app/engineering/materials/$materialId': typeof AppEngineeringMaterialsMaterialIdRouteRouteWithChildren
  '/_app/engineering/materials/functions': typeof AppEngineeringMaterialsFunctionsRouteRouteWithChildren
  '/_app/engineering/services/$serviceId': typeof AppEngineeringServicesServiceIdRouteRouteWithChildren
  '/_app/engineering/services/functions': typeof AppEngineeringServicesFunctionsRouteRouteWithChildren
  '/_app/engineering/suppliers/$supplierId': typeof AppEngineeringSuppliersSupplierIdRouteRouteWithChildren
  '/_app/engineering/suppliers/functions': typeof AppEngineeringSuppliersFunctionsRouteRouteWithChildren
  '/_app/sales/clients/$clientId': typeof AppSalesClientsClientIdRouteRouteWithChildren
  '/_app/sales/expedients/$expedientId': typeof AppSalesExpedientsExpedientIdRouteRouteWithChildren
  '/_app/sales/leads/$leadId': typeof AppSalesLeadsLeadIdRouteRouteWithChildren
  '/_app/sales/offers/$offerId': typeof AppSalesOffersOfferIdRouteRouteWithChildren
  '/_app/sales/offers/templates': typeof AppSalesOffersTemplatesRouteRouteWithChildren
  '/_app/sales/representatives/$representativeId': typeof AppSalesRepresentativesRepresentativeIdRouteRouteWithChildren
  '/_app/user-management/users/$userId': typeof AppUserManagementUsersUserIdRouteRouteWithChildren
  '/_app/user-management/users/roles': typeof AppUserManagementUsersRolesRouteRouteWithChildren
  '/_app/admin/users/': typeof AppAdminUsersIndexRoute
  '/_app/dev/dashboard/': typeof AppDevDashboardIndexRoute
  '/_app/diagram/$diagramId/': typeof AppDiagramDiagramIdIndexRoute
  '/_app/engineering/material-functions/': typeof AppEngineeringMaterialFunctionsIndexRoute
  '/_app/engineering/materials/': typeof AppEngineeringMaterialsIndexRoute
  '/_app/engineering/services/': typeof AppEngineeringServicesIndexRoute
  '/_app/engineering/suppliers/': typeof AppEngineeringSuppliersIndexRoute
  '/_app/sales/clients/': typeof AppSalesClientsIndexRoute
  '/_app/sales/expedients/': typeof AppSalesExpedientsIndexRoute
  '/_app/sales/leads/': typeof AppSalesLeadsIndexRoute
  '/_app/sales/offer-templates/': typeof AppSalesOfferTemplatesIndexRoute
  '/_app/sales/offers/': typeof AppSalesOffersIndexRoute
  '/_app/sales/representatives/': typeof AppSalesRepresentativesIndexRoute
  '/_app/user-management/users/': typeof AppUserManagementUsersIndexRoute
  '/_app/sales/offers/templates/$offerTemplateId': typeof AppSalesOffersTemplatesOfferTemplateIdRouteRouteWithChildren
  '/_app/user-management/users/roles/$roleId': typeof AppUserManagementUsersRolesRoleIdRouteRouteWithChildren
  '/_app/admin/users/$userId/': typeof AppAdminUsersUserIdIndexRoute
  '/_app/engineering/materials/$materialId/': typeof AppEngineeringMaterialsMaterialIdIndexRoute
  '/_app/engineering/materials/functions/': typeof AppEngineeringMaterialsFunctionsIndexRoute
  '/_app/engineering/services/$serviceId/': typeof AppEngineeringServicesServiceIdIndexRoute
  '/_app/engineering/services/functions/': typeof AppEngineeringServicesFunctionsIndexRoute
  '/_app/engineering/suppliers/$supplierId/': typeof AppEngineeringSuppliersSupplierIdIndexRoute
  '/_app/engineering/suppliers/functions/': typeof AppEngineeringSuppliersFunctionsIndexRoute
  '/_app/sales/clients/$clientId/': typeof AppSalesClientsClientIdIndexRoute
  '/_app/sales/expedients/$expedientId/': typeof AppSalesExpedientsExpedientIdIndexRoute
  '/_app/sales/leads/$leadId/': typeof AppSalesLeadsLeadIdIndexRoute
  '/_app/sales/offers/$offerId/': typeof AppSalesOffersOfferIdIndexRoute
  '/_app/sales/offers/templates/': typeof AppSalesOffersTemplatesIndexRoute
  '/_app/sales/representatives/$representativeId/': typeof AppSalesRepresentativesRepresentativeIdIndexRoute
  '/_app/user-management/users/$userId/': typeof AppUserManagementUsersUserIdIndexRoute
  '/_app/user-management/users/roles/': typeof AppUserManagementUsersRolesIndexRoute
  '/_app/admin/users/$userId/statistics/': typeof AppAdminUsersUserIdStatisticsIndexRoute
  '/_app/admin/users/$userId/tasks/': typeof AppAdminUsersUserIdTasksIndexRoute
  '/_app/engineering/materials/$materialId/composition/': typeof AppEngineeringMaterialsMaterialIdCompositionIndexRoute
  '/_app/engineering/materials/$materialId/descriptions/': typeof AppEngineeringMaterialsMaterialIdDescriptionsIndexRoute
  '/_app/engineering/materials/$materialId/notes/': typeof AppEngineeringMaterialsMaterialIdNotesIndexRoute
  '/_app/engineering/materials/$materialId/offers/': typeof AppEngineeringMaterialsMaterialIdOffersIndexRoute
  '/_app/engineering/services/$serviceId/composition/': typeof AppEngineeringServicesServiceIdCompositionIndexRoute
  '/_app/engineering/services/$serviceId/descriptions/': typeof AppEngineeringServicesServiceIdDescriptionsIndexRoute
  '/_app/engineering/services/$serviceId/notes/': typeof AppEngineeringServicesServiceIdNotesIndexRoute
  '/_app/engineering/services/$serviceId/offers/': typeof AppEngineeringServicesServiceIdOffersIndexRoute
  '/_app/engineering/suppliers/$supplierId/contacts/': typeof AppEngineeringSuppliersSupplierIdContactsIndexRoute
  '/_app/engineering/suppliers/$supplierId/notes/': typeof AppEngineeringSuppliersSupplierIdNotesIndexRoute
  '/_app/engineering/suppliers/$supplierId/offers/': typeof AppEngineeringSuppliersSupplierIdOffersIndexRoute
  '/_app/sales/clients/$clientId/contacts/': typeof AppSalesClientsClientIdContactsIndexRoute
  '/_app/sales/clients/$clientId/notes/': typeof AppSalesClientsClientIdNotesIndexRoute
  '/_app/sales/expedients/$expedientId/notes/': typeof AppSalesExpedientsExpedientIdNotesIndexRoute
  '/_app/sales/expedients/$expedientId/offers/': typeof AppSalesExpedientsExpedientIdOffersIndexRoute
  '/_app/sales/expedients/$expedientId/options/': typeof AppSalesExpedientsExpedientIdOptionsIndexRoute
  '/_app/sales/leads/$leadId/contacts/': typeof AppSalesLeadsLeadIdContactsIndexRoute
  '/_app/sales/leads/$leadId/notes/': typeof AppSalesLeadsLeadIdNotesIndexRoute
  '/_app/sales/offers/$offerId/details/': typeof AppSalesOffersOfferIdDetailsIndexRoute
  '/_app/sales/offers/$offerId/editor/': typeof AppSalesOffersOfferIdEditorIndexRoute
  '/_app/sales/offers/$offerId/history/': typeof AppSalesOffersOfferIdHistoryIndexRoute
  '/_app/sales/offers/$offerId/notes/': typeof AppSalesOffersOfferIdNotesIndexRoute
  '/_app/sales/offers/$offerId/preview/': typeof AppSalesOffersOfferIdPreviewIndexRoute
  '/_app/sales/offers/editor/$customerOfferId/': typeof AppSalesOffersEditorCustomerOfferIdIndexRoute
  '/_app/sales/offers/templates/$offerTemplateId/': typeof AppSalesOffersTemplatesOfferTemplateIdIndexRoute
  '/_app/sales/representatives/$representativeId/commissions/': typeof AppSalesRepresentativesRepresentativeIdCommissionsIndexRoute
  '/_app/sales/representatives/$representativeId/contacts/': typeof AppSalesRepresentativesRepresentativeIdContactsIndexRoute
  '/_app/sales/representatives/$representativeId/notes/': typeof AppSalesRepresentativesRepresentativeIdNotesIndexRoute
  '/_app/user-management/users/$userId/permissions/': typeof AppUserManagementUsersUserIdPermissionsIndexRoute
  '/_app/user-management/users/$userId/roles/': typeof AppUserManagementUsersUserIdRolesIndexRoute
  '/_app/user-management/users/roles/$roleId/': typeof AppUserManagementUsersRolesRoleIdIndexRoute
  '/_app/sales/offers/templates/$offerTemplateId/details/': typeof AppSalesOffersTemplatesOfferTemplateIdDetailsIndexRoute
  '/_app/sales/offers/templates/$offerTemplateId/editor/': typeof AppSalesOffersTemplatesOfferTemplateIdEditorIndexRoute
  '/_app/sales/offers/templates/$offerTemplateId/notes/': typeof AppSalesOffersTemplatesOfferTemplateIdNotesIndexRoute
  '/_app/sales/offers/templates/$offerTemplateId/preview/': typeof AppSalesOffersTemplatesOfferTemplateIdPreviewIndexRoute
  '/_app/sales/offers/templates/editor/$offerTemplateId/': typeof AppSalesOffersTemplatesEditorOfferTemplateIdIndexRoute
  '/_app/user-management/users/roles/$roleId/permissions/': typeof AppUserManagementUsersRolesRoleIdPermissionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/account-not-linked'
    | '/login'
    | '/signed-out'
    | '/admin/users'
    | '/engineering/material-functions'
    | '/engineering/materials'
    | '/engineering/services'
    | '/engineering/suppliers'
    | '/sales/clients'
    | '/sales/expedients'
    | '/sales/leads'
    | '/sales/offer-templates'
    | '/sales/offers'
    | '/sales/representatives'
    | '/user-management/users'
    | '/dashboard/'
    | '/settings/'
    | '/admin/users/$userId'
    | '/engineering/materials/$materialId'
    | '/engineering/materials/functions'
    | '/engineering/services/$serviceId'
    | '/engineering/services/functions'
    | '/engineering/suppliers/$supplierId'
    | '/engineering/suppliers/functions'
    | '/sales/clients/$clientId'
    | '/sales/expedients/$expedientId'
    | '/sales/leads/$leadId'
    | '/sales/offers/$offerId'
    | '/sales/offers/templates'
    | '/sales/representatives/$representativeId'
    | '/user-management/users/$userId'
    | '/user-management/users/roles'
    | '/admin/users/'
    | '/dev/dashboard/'
    | '/diagram/$diagramId/'
    | '/engineering/material-functions/'
    | '/engineering/materials/'
    | '/engineering/services/'
    | '/engineering/suppliers/'
    | '/sales/clients/'
    | '/sales/expedients/'
    | '/sales/leads/'
    | '/sales/offer-templates/'
    | '/sales/offers/'
    | '/sales/representatives/'
    | '/user-management/users/'
    | '/sales/offers/templates/$offerTemplateId'
    | '/user-management/users/roles/$roleId'
    | '/admin/users/$userId/'
    | '/engineering/materials/$materialId/'
    | '/engineering/materials/functions/'
    | '/engineering/services/$serviceId/'
    | '/engineering/services/functions/'
    | '/engineering/suppliers/$supplierId/'
    | '/engineering/suppliers/functions/'
    | '/sales/clients/$clientId/'
    | '/sales/expedients/$expedientId/'
    | '/sales/leads/$leadId/'
    | '/sales/offers/$offerId/'
    | '/sales/offers/templates/'
    | '/sales/representatives/$representativeId/'
    | '/user-management/users/$userId/'
    | '/user-management/users/roles/'
    | '/admin/users/$userId/statistics/'
    | '/admin/users/$userId/tasks/'
    | '/engineering/materials/$materialId/composition/'
    | '/engineering/materials/$materialId/descriptions/'
    | '/engineering/materials/$materialId/notes/'
    | '/engineering/materials/$materialId/offers/'
    | '/engineering/services/$serviceId/composition/'
    | '/engineering/services/$serviceId/descriptions/'
    | '/engineering/services/$serviceId/notes/'
    | '/engineering/services/$serviceId/offers/'
    | '/engineering/suppliers/$supplierId/contacts/'
    | '/engineering/suppliers/$supplierId/notes/'
    | '/engineering/suppliers/$supplierId/offers/'
    | '/sales/clients/$clientId/contacts/'
    | '/sales/clients/$clientId/notes/'
    | '/sales/expedients/$expedientId/notes/'
    | '/sales/expedients/$expedientId/offers/'
    | '/sales/expedients/$expedientId/options/'
    | '/sales/leads/$leadId/contacts/'
    | '/sales/leads/$leadId/notes/'
    | '/sales/offers/$offerId/details/'
    | '/sales/offers/$offerId/editor/'
    | '/sales/offers/$offerId/history/'
    | '/sales/offers/$offerId/notes/'
    | '/sales/offers/$offerId/preview/'
    | '/sales/offers/editor/$customerOfferId/'
    | '/sales/offers/templates/$offerTemplateId/'
    | '/sales/representatives/$representativeId/commissions/'
    | '/sales/representatives/$representativeId/contacts/'
    | '/sales/representatives/$representativeId/notes/'
    | '/user-management/users/$userId/permissions/'
    | '/user-management/users/$userId/roles/'
    | '/user-management/users/roles/$roleId/'
    | '/sales/offers/templates/$offerTemplateId/details/'
    | '/sales/offers/templates/$offerTemplateId/editor/'
    | '/sales/offers/templates/$offerTemplateId/notes/'
    | '/sales/offers/templates/$offerTemplateId/preview/'
    | '/sales/offers/templates/editor/$offerTemplateId/'
    | '/user-management/users/roles/$roleId/permissions/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/account-not-linked'
    | '/login'
    | '/signed-out'
    | '/dashboard'
    | '/settings'
    | '/admin/users'
    | '/dev/dashboard'
    | '/diagram/$diagramId'
    | '/engineering/material-functions'
    | '/engineering/materials'
    | '/engineering/services'
    | '/engineering/suppliers'
    | '/sales/clients'
    | '/sales/expedients'
    | '/sales/leads'
    | '/sales/offer-templates'
    | '/sales/offers'
    | '/sales/representatives'
    | '/user-management/users'
    | '/admin/users/$userId'
    | '/engineering/materials/$materialId'
    | '/engineering/materials/functions'
    | '/engineering/services/$serviceId'
    | '/engineering/services/functions'
    | '/engineering/suppliers/$supplierId'
    | '/engineering/suppliers/functions'
    | '/sales/clients/$clientId'
    | '/sales/expedients/$expedientId'
    | '/sales/leads/$leadId'
    | '/sales/offers/$offerId'
    | '/sales/offers/templates'
    | '/sales/representatives/$representativeId'
    | '/user-management/users/$userId'
    | '/user-management/users/roles'
    | '/admin/users/$userId/statistics'
    | '/admin/users/$userId/tasks'
    | '/engineering/materials/$materialId/composition'
    | '/engineering/materials/$materialId/descriptions'
    | '/engineering/materials/$materialId/notes'
    | '/engineering/materials/$materialId/offers'
    | '/engineering/services/$serviceId/composition'
    | '/engineering/services/$serviceId/descriptions'
    | '/engineering/services/$serviceId/notes'
    | '/engineering/services/$serviceId/offers'
    | '/engineering/suppliers/$supplierId/contacts'
    | '/engineering/suppliers/$supplierId/notes'
    | '/engineering/suppliers/$supplierId/offers'
    | '/sales/clients/$clientId/contacts'
    | '/sales/clients/$clientId/notes'
    | '/sales/expedients/$expedientId/notes'
    | '/sales/expedients/$expedientId/offers'
    | '/sales/expedients/$expedientId/options'
    | '/sales/leads/$leadId/contacts'
    | '/sales/leads/$leadId/notes'
    | '/sales/offers/$offerId/details'
    | '/sales/offers/$offerId/editor'
    | '/sales/offers/$offerId/history'
    | '/sales/offers/$offerId/notes'
    | '/sales/offers/$offerId/preview'
    | '/sales/offers/editor/$customerOfferId'
    | '/sales/offers/templates/$offerTemplateId'
    | '/sales/representatives/$representativeId/commissions'
    | '/sales/representatives/$representativeId/contacts'
    | '/sales/representatives/$representativeId/notes'
    | '/user-management/users/$userId/permissions'
    | '/user-management/users/$userId/roles'
    | '/user-management/users/roles/$roleId'
    | '/sales/offers/templates/$offerTemplateId/details'
    | '/sales/offers/templates/$offerTemplateId/editor'
    | '/sales/offers/templates/$offerTemplateId/notes'
    | '/sales/offers/templates/$offerTemplateId/preview'
    | '/sales/offers/templates/editor/$offerTemplateId'
    | '/user-management/users/roles/$roleId/permissions'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/account-not-linked'
    | '/login'
    | '/signed-out'
    | '/_app/admin/users'
    | '/_app/engineering/material-functions'
    | '/_app/engineering/materials'
    | '/_app/engineering/services'
    | '/_app/engineering/suppliers'
    | '/_app/sales/clients'
    | '/_app/sales/expedients'
    | '/_app/sales/leads'
    | '/_app/sales/offer-templates'
    | '/_app/sales/offers'
    | '/_app/sales/representatives'
    | '/_app/user-management/users'
    | '/_app/dashboard/'
    | '/_app/settings/'
    | '/_app/admin/users/$userId'
    | '/_app/engineering/materials/$materialId'
    | '/_app/engineering/materials/functions'
    | '/_app/engineering/services/$serviceId'
    | '/_app/engineering/services/functions'
    | '/_app/engineering/suppliers/$supplierId'
    | '/_app/engineering/suppliers/functions'
    | '/_app/sales/clients/$clientId'
    | '/_app/sales/expedients/$expedientId'
    | '/_app/sales/leads/$leadId'
    | '/_app/sales/offers/$offerId'
    | '/_app/sales/offers/templates'
    | '/_app/sales/representatives/$representativeId'
    | '/_app/user-management/users/$userId'
    | '/_app/user-management/users/roles'
    | '/_app/admin/users/'
    | '/_app/dev/dashboard/'
    | '/_app/diagram/$diagramId/'
    | '/_app/engineering/material-functions/'
    | '/_app/engineering/materials/'
    | '/_app/engineering/services/'
    | '/_app/engineering/suppliers/'
    | '/_app/sales/clients/'
    | '/_app/sales/expedients/'
    | '/_app/sales/leads/'
    | '/_app/sales/offer-templates/'
    | '/_app/sales/offers/'
    | '/_app/sales/representatives/'
    | '/_app/user-management/users/'
    | '/_app/sales/offers/templates/$offerTemplateId'
    | '/_app/user-management/users/roles/$roleId'
    | '/_app/admin/users/$userId/'
    | '/_app/engineering/materials/$materialId/'
    | '/_app/engineering/materials/functions/'
    | '/_app/engineering/services/$serviceId/'
    | '/_app/engineering/services/functions/'
    | '/_app/engineering/suppliers/$supplierId/'
    | '/_app/engineering/suppliers/functions/'
    | '/_app/sales/clients/$clientId/'
    | '/_app/sales/expedients/$expedientId/'
    | '/_app/sales/leads/$leadId/'
    | '/_app/sales/offers/$offerId/'
    | '/_app/sales/offers/templates/'
    | '/_app/sales/representatives/$representativeId/'
    | '/_app/user-management/users/$userId/'
    | '/_app/user-management/users/roles/'
    | '/_app/admin/users/$userId/statistics/'
    | '/_app/admin/users/$userId/tasks/'
    | '/_app/engineering/materials/$materialId/composition/'
    | '/_app/engineering/materials/$materialId/descriptions/'
    | '/_app/engineering/materials/$materialId/notes/'
    | '/_app/engineering/materials/$materialId/offers/'
    | '/_app/engineering/services/$serviceId/composition/'
    | '/_app/engineering/services/$serviceId/descriptions/'
    | '/_app/engineering/services/$serviceId/notes/'
    | '/_app/engineering/services/$serviceId/offers/'
    | '/_app/engineering/suppliers/$supplierId/contacts/'
    | '/_app/engineering/suppliers/$supplierId/notes/'
    | '/_app/engineering/suppliers/$supplierId/offers/'
    | '/_app/sales/clients/$clientId/contacts/'
    | '/_app/sales/clients/$clientId/notes/'
    | '/_app/sales/expedients/$expedientId/notes/'
    | '/_app/sales/expedients/$expedientId/offers/'
    | '/_app/sales/expedients/$expedientId/options/'
    | '/_app/sales/leads/$leadId/contacts/'
    | '/_app/sales/leads/$leadId/notes/'
    | '/_app/sales/offers/$offerId/details/'
    | '/_app/sales/offers/$offerId/editor/'
    | '/_app/sales/offers/$offerId/history/'
    | '/_app/sales/offers/$offerId/notes/'
    | '/_app/sales/offers/$offerId/preview/'
    | '/_app/sales/offers/editor/$customerOfferId/'
    | '/_app/sales/offers/templates/$offerTemplateId/'
    | '/_app/sales/representatives/$representativeId/commissions/'
    | '/_app/sales/representatives/$representativeId/contacts/'
    | '/_app/sales/representatives/$representativeId/notes/'
    | '/_app/user-management/users/$userId/permissions/'
    | '/_app/user-management/users/$userId/roles/'
    | '/_app/user-management/users/roles/$roleId/'
    | '/_app/sales/offers/templates/$offerTemplateId/details/'
    | '/_app/sales/offers/templates/$offerTemplateId/editor/'
    | '/_app/sales/offers/templates/$offerTemplateId/notes/'
    | '/_app/sales/offers/templates/$offerTemplateId/preview/'
    | '/_app/sales/offers/templates/editor/$offerTemplateId/'
    | '/_app/user-management/users/roles/$roleId/permissions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AccountNotLinkedRoute: typeof AccountNotLinkedRoute
  LoginRoute: typeof LoginRoute
  SignedOutRoute: typeof SignedOutRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signed-out': {
      id: '/signed-out'
      path: '/signed-out'
      fullPath: '/signed-out'
      preLoaderRoute: typeof SignedOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/account-not-linked': {
      id: '/account-not-linked'
      path: '/account-not-linked'
      fullPath: '/account-not-linked'
      preLoaderRoute: typeof AccountNotLinkedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/dashboard/': {
      id: '/_app/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AppDashboardIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/user-management/users': {
      id: '/_app/user-management/users'
      path: '/user-management/users'
      fullPath: '/user-management/users'
      preLoaderRoute: typeof AppUserManagementUsersRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/sales/representatives': {
      id: '/_app/sales/representatives'
      path: '/sales/representatives'
      fullPath: '/sales/representatives'
      preLoaderRoute: typeof AppSalesRepresentativesRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/sales/offers': {
      id: '/_app/sales/offers'
      path: '/sales/offers'
      fullPath: '/sales/offers'
      preLoaderRoute: typeof AppSalesOffersRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/sales/offer-templates': {
      id: '/_app/sales/offer-templates'
      path: '/sales/offer-templates'
      fullPath: '/sales/offer-templates'
      preLoaderRoute: typeof AppSalesOfferTemplatesRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/sales/leads': {
      id: '/_app/sales/leads'
      path: '/sales/leads'
      fullPath: '/sales/leads'
      preLoaderRoute: typeof AppSalesLeadsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/sales/expedients': {
      id: '/_app/sales/expedients'
      path: '/sales/expedients'
      fullPath: '/sales/expedients'
      preLoaderRoute: typeof AppSalesExpedientsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/sales/clients': {
      id: '/_app/sales/clients'
      path: '/sales/clients'
      fullPath: '/sales/clients'
      preLoaderRoute: typeof AppSalesClientsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/engineering/suppliers': {
      id: '/_app/engineering/suppliers'
      path: '/engineering/suppliers'
      fullPath: '/engineering/suppliers'
      preLoaderRoute: typeof AppEngineeringSuppliersRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/engineering/services': {
      id: '/_app/engineering/services'
      path: '/engineering/services'
      fullPath: '/engineering/services'
      preLoaderRoute: typeof AppEngineeringServicesRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/engineering/materials': {
      id: '/_app/engineering/materials'
      path: '/engineering/materials'
      fullPath: '/engineering/materials'
      preLoaderRoute: typeof AppEngineeringMaterialsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/engineering/material-functions': {
      id: '/_app/engineering/material-functions'
      path: '/engineering/material-functions'
      fullPath: '/engineering/material-functions'
      preLoaderRoute: typeof AppEngineeringMaterialFunctionsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/admin/users': {
      id: '/_app/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AppAdminUsersRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/user-management/users/': {
      id: '/_app/user-management/users/'
      path: '/'
      fullPath: '/user-management/users/'
      preLoaderRoute: typeof AppUserManagementUsersIndexRouteImport
      parentRoute: typeof AppUserManagementUsersRouteRoute
    }
    '/_app/sales/representatives/': {
      id: '/_app/sales/representatives/'
      path: '/'
      fullPath: '/sales/representatives/'
      preLoaderRoute: typeof AppSalesRepresentativesIndexRouteImport
      parentRoute: typeof AppSalesRepresentativesRouteRoute
    }
    '/_app/sales/offers/': {
      id: '/_app/sales/offers/'
      path: '/'
      fullPath: '/sales/offers/'
      preLoaderRoute: typeof AppSalesOffersIndexRouteImport
      parentRoute: typeof AppSalesOffersRouteRoute
    }
    '/_app/sales/offer-templates/': {
      id: '/_app/sales/offer-templates/'
      path: '/'
      fullPath: '/sales/offer-templates/'
      preLoaderRoute: typeof AppSalesOfferTemplatesIndexRouteImport
      parentRoute: typeof AppSalesOfferTemplatesRouteRoute
    }
    '/_app/sales/leads/': {
      id: '/_app/sales/leads/'
      path: '/'
      fullPath: '/sales/leads/'
      preLoaderRoute: typeof AppSalesLeadsIndexRouteImport
      parentRoute: typeof AppSalesLeadsRouteRoute
    }
    '/_app/sales/expedients/': {
      id: '/_app/sales/expedients/'
      path: '/'
      fullPath: '/sales/expedients/'
      preLoaderRoute: typeof AppSalesExpedientsIndexRouteImport
      parentRoute: typeof AppSalesExpedientsRouteRoute
    }
    '/_app/sales/clients/': {
      id: '/_app/sales/clients/'
      path: '/'
      fullPath: '/sales/clients/'
      preLoaderRoute: typeof AppSalesClientsIndexRouteImport
      parentRoute: typeof AppSalesClientsRouteRoute
    }
    '/_app/engineering/suppliers/': {
      id: '/_app/engineering/suppliers/'
      path: '/'
      fullPath: '/engineering/suppliers/'
      preLoaderRoute: typeof AppEngineeringSuppliersIndexRouteImport
      parentRoute: typeof AppEngineeringSuppliersRouteRoute
    }
    '/_app/engineering/services/': {
      id: '/_app/engineering/services/'
      path: '/'
      fullPath: '/engineering/services/'
      preLoaderRoute: typeof AppEngineeringServicesIndexRouteImport
      parentRoute: typeof AppEngineeringServicesRouteRoute
    }
    '/_app/engineering/materials/': {
      id: '/_app/engineering/materials/'
      path: '/'
      fullPath: '/engineering/materials/'
      preLoaderRoute: typeof AppEngineeringMaterialsIndexRouteImport
      parentRoute: typeof AppEngineeringMaterialsRouteRoute
    }
    '/_app/engineering/material-functions/': {
      id: '/_app/engineering/material-functions/'
      path: '/'
      fullPath: '/engineering/material-functions/'
      preLoaderRoute: typeof AppEngineeringMaterialFunctionsIndexRouteImport
      parentRoute: typeof AppEngineeringMaterialFunctionsRouteRoute
    }
    '/_app/diagram/$diagramId/': {
      id: '/_app/diagram/$diagramId/'
      path: '/diagram/$diagramId'
      fullPath: '/diagram/$diagramId/'
      preLoaderRoute: typeof AppDiagramDiagramIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/dev/dashboard/': {
      id: '/_app/dev/dashboard/'
      path: '/dev/dashboard'
      fullPath: '/dev/dashboard/'
      preLoaderRoute: typeof AppDevDashboardIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/admin/users/': {
      id: '/_app/admin/users/'
      path: '/'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AppAdminUsersIndexRouteImport
      parentRoute: typeof AppAdminUsersRouteRoute
    }
    '/_app/user-management/users/roles': {
      id: '/_app/user-management/users/roles'
      path: '/roles'
      fullPath: '/user-management/users/roles'
      preLoaderRoute: typeof AppUserManagementUsersRolesRouteRouteImport
      parentRoute: typeof AppUserManagementUsersRouteRoute
    }
    '/_app/user-management/users/$userId': {
      id: '/_app/user-management/users/$userId'
      path: '/$userId'
      fullPath: '/user-management/users/$userId'
      preLoaderRoute: typeof AppUserManagementUsersUserIdRouteRouteImport
      parentRoute: typeof AppUserManagementUsersRouteRoute
    }
    '/_app/sales/representatives/$representativeId': {
      id: '/_app/sales/representatives/$representativeId'
      path: '/$representativeId'
      fullPath: '/sales/representatives/$representativeId'
      preLoaderRoute: typeof AppSalesRepresentativesRepresentativeIdRouteRouteImport
      parentRoute: typeof AppSalesRepresentativesRouteRoute
    }
    '/_app/sales/offers/templates': {
      id: '/_app/sales/offers/templates'
      path: '/templates'
      fullPath: '/sales/offers/templates'
      preLoaderRoute: typeof AppSalesOffersTemplatesRouteRouteImport
      parentRoute: typeof AppSalesOffersRouteRoute
    }
    '/_app/sales/offers/$offerId': {
      id: '/_app/sales/offers/$offerId'
      path: '/$offerId'
      fullPath: '/sales/offers/$offerId'
      preLoaderRoute: typeof AppSalesOffersOfferIdRouteRouteImport
      parentRoute: typeof AppSalesOffersRouteRoute
    }
    '/_app/sales/leads/$leadId': {
      id: '/_app/sales/leads/$leadId'
      path: '/$leadId'
      fullPath: '/sales/leads/$leadId'
      preLoaderRoute: typeof AppSalesLeadsLeadIdRouteRouteImport
      parentRoute: typeof AppSalesLeadsRouteRoute
    }
    '/_app/sales/expedients/$expedientId': {
      id: '/_app/sales/expedients/$expedientId'
      path: '/$expedientId'
      fullPath: '/sales/expedients/$expedientId'
      preLoaderRoute: typeof AppSalesExpedientsExpedientIdRouteRouteImport
      parentRoute: typeof AppSalesExpedientsRouteRoute
    }
    '/_app/sales/clients/$clientId': {
      id: '/_app/sales/clients/$clientId'
      path: '/$clientId'
      fullPath: '/sales/clients/$clientId'
      preLoaderRoute: typeof AppSalesClientsClientIdRouteRouteImport
      parentRoute: typeof AppSalesClientsRouteRoute
    }
    '/_app/engineering/suppliers/functions': {
      id: '/_app/engineering/suppliers/functions'
      path: '/functions'
      fullPath: '/engineering/suppliers/functions'
      preLoaderRoute: typeof AppEngineeringSuppliersFunctionsRouteRouteImport
      parentRoute: typeof AppEngineeringSuppliersRouteRoute
    }
    '/_app/engineering/suppliers/$supplierId': {
      id: '/_app/engineering/suppliers/$supplierId'
      path: '/$supplierId'
      fullPath: '/engineering/suppliers/$supplierId'
      preLoaderRoute: typeof AppEngineeringSuppliersSupplierIdRouteRouteImport
      parentRoute: typeof AppEngineeringSuppliersRouteRoute
    }
    '/_app/engineering/services/functions': {
      id: '/_app/engineering/services/functions'
      path: '/functions'
      fullPath: '/engineering/services/functions'
      preLoaderRoute: typeof AppEngineeringServicesFunctionsRouteRouteImport
      parentRoute: typeof AppEngineeringServicesRouteRoute
    }
    '/_app/engineering/services/$serviceId': {
      id: '/_app/engineering/services/$serviceId'
      path: '/$serviceId'
      fullPath: '/engineering/services/$serviceId'
      preLoaderRoute: typeof AppEngineeringServicesServiceIdRouteRouteImport
      parentRoute: typeof AppEngineeringServicesRouteRoute
    }
    '/_app/engineering/materials/functions': {
      id: '/_app/engineering/materials/functions'
      path: '/functions'
      fullPath: '/engineering/materials/functions'
      preLoaderRoute: typeof AppEngineeringMaterialsFunctionsRouteRouteImport
      parentRoute: typeof AppEngineeringMaterialsRouteRoute
    }
    '/_app/engineering/materials/$materialId': {
      id: '/_app/engineering/materials/$materialId'
      path: '/$materialId'
      fullPath: '/engineering/materials/$materialId'
      preLoaderRoute: typeof AppEngineeringMaterialsMaterialIdRouteRouteImport
      parentRoute: typeof AppEngineeringMaterialsRouteRoute
    }
    '/_app/admin/users/$userId': {
      id: '/_app/admin/users/$userId'
      path: '/$userId'
      fullPath: '/admin/users/$userId'
      preLoaderRoute: typeof AppAdminUsersUserIdRouteRouteImport
      parentRoute: typeof AppAdminUsersRouteRoute
    }
    '/_app/user-management/users/roles/': {
      id: '/_app/user-management/users/roles/'
      path: '/'
      fullPath: '/user-management/users/roles/'
      preLoaderRoute: typeof AppUserManagementUsersRolesIndexRouteImport
      parentRoute: typeof AppUserManagementUsersRolesRouteRoute
    }
    '/_app/user-management/users/$userId/': {
      id: '/_app/user-management/users/$userId/'
      path: '/'
      fullPath: '/user-management/users/$userId/'
      preLoaderRoute: typeof AppUserManagementUsersUserIdIndexRouteImport
      parentRoute: typeof AppUserManagementUsersUserIdRouteRoute
    }
    '/_app/sales/representatives/$representativeId/': {
      id: '/_app/sales/representatives/$representativeId/'
      path: '/'
      fullPath: '/sales/representatives/$representativeId/'
      preLoaderRoute: typeof AppSalesRepresentativesRepresentativeIdIndexRouteImport
      parentRoute: typeof AppSalesRepresentativesRepresentativeIdRouteRoute
    }
    '/_app/sales/offers/templates/': {
      id: '/_app/sales/offers/templates/'
      path: '/'
      fullPath: '/sales/offers/templates/'
      preLoaderRoute: typeof AppSalesOffersTemplatesIndexRouteImport
      parentRoute: typeof AppSalesOffersTemplatesRouteRoute
    }
    '/_app/sales/offers/$offerId/': {
      id: '/_app/sales/offers/$offerId/'
      path: '/'
      fullPath: '/sales/offers/$offerId/'
      preLoaderRoute: typeof AppSalesOffersOfferIdIndexRouteImport
      parentRoute: typeof AppSalesOffersOfferIdRouteRoute
    }
    '/_app/sales/leads/$leadId/': {
      id: '/_app/sales/leads/$leadId/'
      path: '/'
      fullPath: '/sales/leads/$leadId/'
      preLoaderRoute: typeof AppSalesLeadsLeadIdIndexRouteImport
      parentRoute: typeof AppSalesLeadsLeadIdRouteRoute
    }
    '/_app/sales/expedients/$expedientId/': {
      id: '/_app/sales/expedients/$expedientId/'
      path: '/'
      fullPath: '/sales/expedients/$expedientId/'
      preLoaderRoute: typeof AppSalesExpedientsExpedientIdIndexRouteImport
      parentRoute: typeof AppSalesExpedientsExpedientIdRouteRoute
    }
    '/_app/sales/clients/$clientId/': {
      id: '/_app/sales/clients/$clientId/'
      path: '/'
      fullPath: '/sales/clients/$clientId/'
      preLoaderRoute: typeof AppSalesClientsClientIdIndexRouteImport
      parentRoute: typeof AppSalesClientsClientIdRouteRoute
    }
    '/_app/engineering/suppliers/functions/': {
      id: '/_app/engineering/suppliers/functions/'
      path: '/'
      fullPath: '/engineering/suppliers/functions/'
      preLoaderRoute: typeof AppEngineeringSuppliersFunctionsIndexRouteImport
      parentRoute: typeof AppEngineeringSuppliersFunctionsRouteRoute
    }
    '/_app/engineering/suppliers/$supplierId/': {
      id: '/_app/engineering/suppliers/$supplierId/'
      path: '/'
      fullPath: '/engineering/suppliers/$supplierId/'
      preLoaderRoute: typeof AppEngineeringSuppliersSupplierIdIndexRouteImport
      parentRoute: typeof AppEngineeringSuppliersSupplierIdRouteRoute
    }
    '/_app/engineering/services/functions/': {
      id: '/_app/engineering/services/functions/'
      path: '/'
      fullPath: '/engineering/services/functions/'
      preLoaderRoute: typeof AppEngineeringServicesFunctionsIndexRouteImport
      parentRoute: typeof AppEngineeringServicesFunctionsRouteRoute
    }
    '/_app/engineering/services/$serviceId/': {
      id: '/_app/engineering/services/$serviceId/'
      path: '/'
      fullPath: '/engineering/services/$serviceId/'
      preLoaderRoute: typeof AppEngineeringServicesServiceIdIndexRouteImport
      parentRoute: typeof AppEngineeringServicesServiceIdRouteRoute
    }
    '/_app/engineering/materials/functions/': {
      id: '/_app/engineering/materials/functions/'
      path: '/'
      fullPath: '/engineering/materials/functions/'
      preLoaderRoute: typeof AppEngineeringMaterialsFunctionsIndexRouteImport
      parentRoute: typeof AppEngineeringMaterialsFunctionsRouteRoute
    }
    '/_app/engineering/materials/$materialId/': {
      id: '/_app/engineering/materials/$materialId/'
      path: '/'
      fullPath: '/engineering/materials/$materialId/'
      preLoaderRoute: typeof AppEngineeringMaterialsMaterialIdIndexRouteImport
      parentRoute: typeof AppEngineeringMaterialsMaterialIdRouteRoute
    }
    '/_app/admin/users/$userId/': {
      id: '/_app/admin/users/$userId/'
      path: '/'
      fullPath: '/admin/users/$userId/'
      preLoaderRoute: typeof AppAdminUsersUserIdIndexRouteImport
      parentRoute: typeof AppAdminUsersUserIdRouteRoute
    }
    '/_app/user-management/users/roles/$roleId': {
      id: '/_app/user-management/users/roles/$roleId'
      path: '/$roleId'
      fullPath: '/user-management/users/roles/$roleId'
      preLoaderRoute: typeof AppUserManagementUsersRolesRoleIdRouteRouteImport
      parentRoute: typeof AppUserManagementUsersRolesRouteRoute
    }
    '/_app/sales/offers/templates/$offerTemplateId': {
      id: '/_app/sales/offers/templates/$offerTemplateId'
      path: '/$offerTemplateId'
      fullPath: '/sales/offers/templates/$offerTemplateId'
      preLoaderRoute: typeof AppSalesOffersTemplatesOfferTemplateIdRouteRouteImport
      parentRoute: typeof AppSalesOffersTemplatesRouteRoute
    }
    '/_app/user-management/users/roles/$roleId/': {
      id: '/_app/user-management/users/roles/$roleId/'
      path: '/'
      fullPath: '/user-management/users/roles/$roleId/'
      preLoaderRoute: typeof AppUserManagementUsersRolesRoleIdIndexRouteImport
      parentRoute: typeof AppUserManagementUsersRolesRoleIdRouteRoute
    }
    '/_app/user-management/users/$userId/roles/': {
      id: '/_app/user-management/users/$userId/roles/'
      path: '/roles'
      fullPath: '/user-management/users/$userId/roles/'
      preLoaderRoute: typeof AppUserManagementUsersUserIdRolesIndexRouteImport
      parentRoute: typeof AppUserManagementUsersUserIdRouteRoute
    }
    '/_app/user-management/users/$userId/permissions/': {
      id: '/_app/user-management/users/$userId/permissions/'
      path: '/permissions'
      fullPath: '/user-management/users/$userId/permissions/'
      preLoaderRoute: typeof AppUserManagementUsersUserIdPermissionsIndexRouteImport
      parentRoute: typeof AppUserManagementUsersUserIdRouteRoute
    }
    '/_app/sales/representatives/$representativeId/notes/': {
      id: '/_app/sales/representatives/$representativeId/notes/'
      path: '/notes'
      fullPath: '/sales/representatives/$representativeId/notes/'
      preLoaderRoute: typeof AppSalesRepresentativesRepresentativeIdNotesIndexRouteImport
      parentRoute: typeof AppSalesRepresentativesRepresentativeIdRouteRoute
    }
    '/_app/sales/representatives/$representativeId/contacts/': {
      id: '/_app/sales/representatives/$representativeId/contacts/'
      path: '/contacts'
      fullPath: '/sales/representatives/$representativeId/contacts/'
      preLoaderRoute: typeof AppSalesRepresentativesRepresentativeIdContactsIndexRouteImport
      parentRoute: typeof AppSalesRepresentativesRepresentativeIdRouteRoute
    }
    '/_app/sales/representatives/$representativeId/commissions/': {
      id: '/_app/sales/representatives/$representativeId/commissions/'
      path: '/commissions'
      fullPath: '/sales/representatives/$representativeId/commissions/'
      preLoaderRoute: typeof AppSalesRepresentativesRepresentativeIdCommissionsIndexRouteImport
      parentRoute: typeof AppSalesRepresentativesRepresentativeIdRouteRoute
    }
    '/_app/sales/offers/templates/$offerTemplateId/': {
      id: '/_app/sales/offers/templates/$offerTemplateId/'
      path: '/'
      fullPath: '/sales/offers/templates/$offerTemplateId/'
      preLoaderRoute: typeof AppSalesOffersTemplatesOfferTemplateIdIndexRouteImport
      parentRoute: typeof AppSalesOffersTemplatesOfferTemplateIdRouteRoute
    }
    '/_app/sales/offers/editor/$customerOfferId/': {
      id: '/_app/sales/offers/editor/$customerOfferId/'
      path: '/editor/$customerOfferId'
      fullPath: '/sales/offers/editor/$customerOfferId/'
      preLoaderRoute: typeof AppSalesOffersEditorCustomerOfferIdIndexRouteImport
      parentRoute: typeof AppSalesOffersRouteRoute
    }
    '/_app/sales/offers/$offerId/preview/': {
      id: '/_app/sales/offers/$offerId/preview/'
      path: '/preview'
      fullPath: '/sales/offers/$offerId/preview/'
      preLoaderRoute: typeof AppSalesOffersOfferIdPreviewIndexRouteImport
      parentRoute: typeof AppSalesOffersOfferIdRouteRoute
    }
    '/_app/sales/offers/$offerId/notes/': {
      id: '/_app/sales/offers/$offerId/notes/'
      path: '/notes'
      fullPath: '/sales/offers/$offerId/notes/'
      preLoaderRoute: typeof AppSalesOffersOfferIdNotesIndexRouteImport
      parentRoute: typeof AppSalesOffersOfferIdRouteRoute
    }
    '/_app/sales/offers/$offerId/history/': {
      id: '/_app/sales/offers/$offerId/history/'
      path: '/history'
      fullPath: '/sales/offers/$offerId/history/'
      preLoaderRoute: typeof AppSalesOffersOfferIdHistoryIndexRouteImport
      parentRoute: typeof AppSalesOffersOfferIdRouteRoute
    }
    '/_app/sales/offers/$offerId/editor/': {
      id: '/_app/sales/offers/$offerId/editor/'
      path: '/editor'
      fullPath: '/sales/offers/$offerId/editor/'
      preLoaderRoute: typeof AppSalesOffersOfferIdEditorIndexRouteImport
      parentRoute: typeof AppSalesOffersOfferIdRouteRoute
    }
    '/_app/sales/offers/$offerId/details/': {
      id: '/_app/sales/offers/$offerId/details/'
      path: '/details'
      fullPath: '/sales/offers/$offerId/details/'
      preLoaderRoute: typeof AppSalesOffersOfferIdDetailsIndexRouteImport
      parentRoute: typeof AppSalesOffersOfferIdRouteRoute
    }
    '/_app/sales/leads/$leadId/notes/': {
      id: '/_app/sales/leads/$leadId/notes/'
      path: '/notes'
      fullPath: '/sales/leads/$leadId/notes/'
      preLoaderRoute: typeof AppSalesLeadsLeadIdNotesIndexRouteImport
      parentRoute: typeof AppSalesLeadsLeadIdRouteRoute
    }
    '/_app/sales/leads/$leadId/contacts/': {
      id: '/_app/sales/leads/$leadId/contacts/'
      path: '/contacts'
      fullPath: '/sales/leads/$leadId/contacts/'
      preLoaderRoute: typeof AppSalesLeadsLeadIdContactsIndexRouteImport
      parentRoute: typeof AppSalesLeadsLeadIdRouteRoute
    }
    '/_app/sales/expedients/$expedientId/options/': {
      id: '/_app/sales/expedients/$expedientId/options/'
      path: '/options'
      fullPath: '/sales/expedients/$expedientId/options/'
      preLoaderRoute: typeof AppSalesExpedientsExpedientIdOptionsIndexRouteImport
      parentRoute: typeof AppSalesExpedientsExpedientIdRouteRoute
    }
    '/_app/sales/expedients/$expedientId/offers/': {
      id: '/_app/sales/expedients/$expedientId/offers/'
      path: '/offers'
      fullPath: '/sales/expedients/$expedientId/offers/'
      preLoaderRoute: typeof AppSalesExpedientsExpedientIdOffersIndexRouteImport
      parentRoute: typeof AppSalesExpedientsExpedientIdRouteRoute
    }
    '/_app/sales/expedients/$expedientId/notes/': {
      id: '/_app/sales/expedients/$expedientId/notes/'
      path: '/notes'
      fullPath: '/sales/expedients/$expedientId/notes/'
      preLoaderRoute: typeof AppSalesExpedientsExpedientIdNotesIndexRouteImport
      parentRoute: typeof AppSalesExpedientsExpedientIdRouteRoute
    }
    '/_app/sales/clients/$clientId/notes/': {
      id: '/_app/sales/clients/$clientId/notes/'
      path: '/notes'
      fullPath: '/sales/clients/$clientId/notes/'
      preLoaderRoute: typeof AppSalesClientsClientIdNotesIndexRouteImport
      parentRoute: typeof AppSalesClientsClientIdRouteRoute
    }
    '/_app/sales/clients/$clientId/contacts/': {
      id: '/_app/sales/clients/$clientId/contacts/'
      path: '/contacts'
      fullPath: '/sales/clients/$clientId/contacts/'
      preLoaderRoute: typeof AppSalesClientsClientIdContactsIndexRouteImport
      parentRoute: typeof AppSalesClientsClientIdRouteRoute
    }
    '/_app/engineering/suppliers/$supplierId/offers/': {
      id: '/_app/engineering/suppliers/$supplierId/offers/'
      path: '/offers'
      fullPath: '/engineering/suppliers/$supplierId/offers/'
      preLoaderRoute: typeof AppEngineeringSuppliersSupplierIdOffersIndexRouteImport
      parentRoute: typeof AppEngineeringSuppliersSupplierIdRouteRoute
    }
    '/_app/engineering/suppliers/$supplierId/notes/': {
      id: '/_app/engineering/suppliers/$supplierId/notes/'
      path: '/notes'
      fullPath: '/engineering/suppliers/$supplierId/notes/'
      preLoaderRoute: typeof AppEngineeringSuppliersSupplierIdNotesIndexRouteImport
      parentRoute: typeof AppEngineeringSuppliersSupplierIdRouteRoute
    }
    '/_app/engineering/suppliers/$supplierId/contacts/': {
      id: '/_app/engineering/suppliers/$supplierId/contacts/'
      path: '/contacts'
      fullPath: '/engineering/suppliers/$supplierId/contacts/'
      preLoaderRoute: typeof AppEngineeringSuppliersSupplierIdContactsIndexRouteImport
      parentRoute: typeof AppEngineeringSuppliersSupplierIdRouteRoute
    }
    '/_app/engineering/services/$serviceId/offers/': {
      id: '/_app/engineering/services/$serviceId/offers/'
      path: '/offers'
      fullPath: '/engineering/services/$serviceId/offers/'
      preLoaderRoute: typeof AppEngineeringServicesServiceIdOffersIndexRouteImport
      parentRoute: typeof AppEngineeringServicesServiceIdRouteRoute
    }
    '/_app/engineering/services/$serviceId/notes/': {
      id: '/_app/engineering/services/$serviceId/notes/'
      path: '/notes'
      fullPath: '/engineering/services/$serviceId/notes/'
      preLoaderRoute: typeof AppEngineeringServicesServiceIdNotesIndexRouteImport
      parentRoute: typeof AppEngineeringServicesServiceIdRouteRoute
    }
    '/_app/engineering/services/$serviceId/descriptions/': {
      id: '/_app/engineering/services/$serviceId/descriptions/'
      path: '/descriptions'
      fullPath: '/engineering/services/$serviceId/descriptions/'
      preLoaderRoute: typeof AppEngineeringServicesServiceIdDescriptionsIndexRouteImport
      parentRoute: typeof AppEngineeringServicesServiceIdRouteRoute
    }
    '/_app/engineering/services/$serviceId/composition/': {
      id: '/_app/engineering/services/$serviceId/composition/'
      path: '/composition'
      fullPath: '/engineering/services/$serviceId/composition/'
      preLoaderRoute: typeof AppEngineeringServicesServiceIdCompositionIndexRouteImport
      parentRoute: typeof AppEngineeringServicesServiceIdRouteRoute
    }
    '/_app/engineering/materials/$materialId/offers/': {
      id: '/_app/engineering/materials/$materialId/offers/'
      path: '/offers'
      fullPath: '/engineering/materials/$materialId/offers/'
      preLoaderRoute: typeof AppEngineeringMaterialsMaterialIdOffersIndexRouteImport
      parentRoute: typeof AppEngineeringMaterialsMaterialIdRouteRoute
    }
    '/_app/engineering/materials/$materialId/notes/': {
      id: '/_app/engineering/materials/$materialId/notes/'
      path: '/notes'
      fullPath: '/engineering/materials/$materialId/notes/'
      preLoaderRoute: typeof AppEngineeringMaterialsMaterialIdNotesIndexRouteImport
      parentRoute: typeof AppEngineeringMaterialsMaterialIdRouteRoute
    }
    '/_app/engineering/materials/$materialId/descriptions/': {
      id: '/_app/engineering/materials/$materialId/descriptions/'
      path: '/descriptions'
      fullPath: '/engineering/materials/$materialId/descriptions/'
      preLoaderRoute: typeof AppEngineeringMaterialsMaterialIdDescriptionsIndexRouteImport
      parentRoute: typeof AppEngineeringMaterialsMaterialIdRouteRoute
    }
    '/_app/engineering/materials/$materialId/composition/': {
      id: '/_app/engineering/materials/$materialId/composition/'
      path: '/composition'
      fullPath: '/engineering/materials/$materialId/composition/'
      preLoaderRoute: typeof AppEngineeringMaterialsMaterialIdCompositionIndexRouteImport
      parentRoute: typeof AppEngineeringMaterialsMaterialIdRouteRoute
    }
    '/_app/admin/users/$userId/tasks/': {
      id: '/_app/admin/users/$userId/tasks/'
      path: '/tasks'
      fullPath: '/admin/users/$userId/tasks/'
      preLoaderRoute: typeof AppAdminUsersUserIdTasksIndexRouteImport
      parentRoute: typeof AppAdminUsersUserIdRouteRoute
    }
    '/_app/admin/users/$userId/statistics/': {
      id: '/_app/admin/users/$userId/statistics/'
      path: '/statistics'
      fullPath: '/admin/users/$userId/statistics/'
      preLoaderRoute: typeof AppAdminUsersUserIdStatisticsIndexRouteImport
      parentRoute: typeof AppAdminUsersUserIdRouteRoute
    }
    '/_app/user-management/users/roles/$roleId/permissions/': {
      id: '/_app/user-management/users/roles/$roleId/permissions/'
      path: '/permissions'
      fullPath: '/user-management/users/roles/$roleId/permissions/'
      preLoaderRoute: typeof AppUserManagementUsersRolesRoleIdPermissionsIndexRouteImport
      parentRoute: typeof AppUserManagementUsersRolesRoleIdRouteRoute
    }
    '/_app/sales/offers/templates/editor/$offerTemplateId/': {
      id: '/_app/sales/offers/templates/editor/$offerTemplateId/'
      path: '/editor/$offerTemplateId'
      fullPath: '/sales/offers/templates/editor/$offerTemplateId/'
      preLoaderRoute: typeof AppSalesOffersTemplatesEditorOfferTemplateIdIndexRouteImport
      parentRoute: typeof AppSalesOffersTemplatesRouteRoute
    }
    '/_app/sales/offers/templates/$offerTemplateId/preview/': {
      id: '/_app/sales/offers/templates/$offerTemplateId/preview/'
      path: '/preview'
      fullPath: '/sales/offers/templates/$offerTemplateId/preview/'
      preLoaderRoute: typeof AppSalesOffersTemplatesOfferTemplateIdPreviewIndexRouteImport
      parentRoute: typeof AppSalesOffersTemplatesOfferTemplateIdRouteRoute
    }
    '/_app/sales/offers/templates/$offerTemplateId/notes/': {
      id: '/_app/sales/offers/templates/$offerTemplateId/notes/'
      path: '/notes'
      fullPath: '/sales/offers/templates/$offerTemplateId/notes/'
      preLoaderRoute: typeof AppSalesOffersTemplatesOfferTemplateIdNotesIndexRouteImport
      parentRoute: typeof AppSalesOffersTemplatesOfferTemplateIdRouteRoute
    }
    '/_app/sales/offers/templates/$offerTemplateId/editor/': {
      id: '/_app/sales/offers/templates/$offerTemplateId/editor/'
      path: '/editor'
      fullPath: '/sales/offers/templates/$offerTemplateId/editor/'
      preLoaderRoute: typeof AppSalesOffersTemplatesOfferTemplateIdEditorIndexRouteImport
      parentRoute: typeof AppSalesOffersTemplatesOfferTemplateIdRouteRoute
    }
    '/_app/sales/offers/templates/$offerTemplateId/details/': {
      id: '/_app/sales/offers/templates/$offerTemplateId/details/'
      path: '/details'
      fullPath: '/sales/offers/templates/$offerTemplateId/details/'
      preLoaderRoute: typeof AppSalesOffersTemplatesOfferTemplateIdDetailsIndexRouteImport
      parentRoute: typeof AppSalesOffersTemplatesOfferTemplateIdRouteRoute
    }
  }
}

interface AppAdminUsersUserIdRouteRouteChildren {
  AppAdminUsersUserIdIndexRoute: typeof AppAdminUsersUserIdIndexRoute
  AppAdminUsersUserIdStatisticsIndexRoute: typeof AppAdminUsersUserIdStatisticsIndexRoute
  AppAdminUsersUserIdTasksIndexRoute: typeof AppAdminUsersUserIdTasksIndexRoute
}

const AppAdminUsersUserIdRouteRouteChildren: AppAdminUsersUserIdRouteRouteChildren =
  {
    AppAdminUsersUserIdIndexRoute: AppAdminUsersUserIdIndexRoute,
    AppAdminUsersUserIdStatisticsIndexRoute:
      AppAdminUsersUserIdStatisticsIndexRoute,
    AppAdminUsersUserIdTasksIndexRoute: AppAdminUsersUserIdTasksIndexRoute,
  }

const AppAdminUsersUserIdRouteRouteWithChildren =
  AppAdminUsersUserIdRouteRoute._addFileChildren(
    AppAdminUsersUserIdRouteRouteChildren,
  )

interface AppAdminUsersRouteRouteChildren {
  AppAdminUsersUserIdRouteRoute: typeof AppAdminUsersUserIdRouteRouteWithChildren
  AppAdminUsersIndexRoute: typeof AppAdminUsersIndexRoute
}

const AppAdminUsersRouteRouteChildren: AppAdminUsersRouteRouteChildren = {
  AppAdminUsersUserIdRouteRoute: AppAdminUsersUserIdRouteRouteWithChildren,
  AppAdminUsersIndexRoute: AppAdminUsersIndexRoute,
}

const AppAdminUsersRouteRouteWithChildren =
  AppAdminUsersRouteRoute._addFileChildren(AppAdminUsersRouteRouteChildren)

interface AppEngineeringMaterialFunctionsRouteRouteChildren {
  AppEngineeringMaterialFunctionsIndexRoute: typeof AppEngineeringMaterialFunctionsIndexRoute
}

const AppEngineeringMaterialFunctionsRouteRouteChildren: AppEngineeringMaterialFunctionsRouteRouteChildren =
  {
    AppEngineeringMaterialFunctionsIndexRoute:
      AppEngineeringMaterialFunctionsIndexRoute,
  }

const AppEngineeringMaterialFunctionsRouteRouteWithChildren =
  AppEngineeringMaterialFunctionsRouteRoute._addFileChildren(
    AppEngineeringMaterialFunctionsRouteRouteChildren,
  )

interface AppEngineeringMaterialsMaterialIdRouteRouteChildren {
  AppEngineeringMaterialsMaterialIdIndexRoute: typeof AppEngineeringMaterialsMaterialIdIndexRoute
  AppEngineeringMaterialsMaterialIdCompositionIndexRoute: typeof AppEngineeringMaterialsMaterialIdCompositionIndexRoute
  AppEngineeringMaterialsMaterialIdDescriptionsIndexRoute: typeof AppEngineeringMaterialsMaterialIdDescriptionsIndexRoute
  AppEngineeringMaterialsMaterialIdNotesIndexRoute: typeof AppEngineeringMaterialsMaterialIdNotesIndexRoute
  AppEngineeringMaterialsMaterialIdOffersIndexRoute: typeof AppEngineeringMaterialsMaterialIdOffersIndexRoute
}

const AppEngineeringMaterialsMaterialIdRouteRouteChildren: AppEngineeringMaterialsMaterialIdRouteRouteChildren =
  {
    AppEngineeringMaterialsMaterialIdIndexRoute:
      AppEngineeringMaterialsMaterialIdIndexRoute,
    AppEngineeringMaterialsMaterialIdCompositionIndexRoute:
      AppEngineeringMaterialsMaterialIdCompositionIndexRoute,
    AppEngineeringMaterialsMaterialIdDescriptionsIndexRoute:
      AppEngineeringMaterialsMaterialIdDescriptionsIndexRoute,
    AppEngineeringMaterialsMaterialIdNotesIndexRoute:
      AppEngineeringMaterialsMaterialIdNotesIndexRoute,
    AppEngineeringMaterialsMaterialIdOffersIndexRoute:
      AppEngineeringMaterialsMaterialIdOffersIndexRoute,
  }

const AppEngineeringMaterialsMaterialIdRouteRouteWithChildren =
  AppEngineeringMaterialsMaterialIdRouteRoute._addFileChildren(
    AppEngineeringMaterialsMaterialIdRouteRouteChildren,
  )

interface AppEngineeringMaterialsFunctionsRouteRouteChildren {
  AppEngineeringMaterialsFunctionsIndexRoute: typeof AppEngineeringMaterialsFunctionsIndexRoute
}

const AppEngineeringMaterialsFunctionsRouteRouteChildren: AppEngineeringMaterialsFunctionsRouteRouteChildren =
  {
    AppEngineeringMaterialsFunctionsIndexRoute:
      AppEngineeringMaterialsFunctionsIndexRoute,
  }

const AppEngineeringMaterialsFunctionsRouteRouteWithChildren =
  AppEngineeringMaterialsFunctionsRouteRoute._addFileChildren(
    AppEngineeringMaterialsFunctionsRouteRouteChildren,
  )

interface AppEngineeringMaterialsRouteRouteChildren {
  AppEngineeringMaterialsMaterialIdRouteRoute: typeof AppEngineeringMaterialsMaterialIdRouteRouteWithChildren
  AppEngineeringMaterialsFunctionsRouteRoute: typeof AppEngineeringMaterialsFunctionsRouteRouteWithChildren
  AppEngineeringMaterialsIndexRoute: typeof AppEngineeringMaterialsIndexRoute
}

const AppEngineeringMaterialsRouteRouteChildren: AppEngineeringMaterialsRouteRouteChildren =
  {
    AppEngineeringMaterialsMaterialIdRouteRoute:
      AppEngineeringMaterialsMaterialIdRouteRouteWithChildren,
    AppEngineeringMaterialsFunctionsRouteRoute:
      AppEngineeringMaterialsFunctionsRouteRouteWithChildren,
    AppEngineeringMaterialsIndexRoute: AppEngineeringMaterialsIndexRoute,
  }

const AppEngineeringMaterialsRouteRouteWithChildren =
  AppEngineeringMaterialsRouteRoute._addFileChildren(
    AppEngineeringMaterialsRouteRouteChildren,
  )

interface AppEngineeringServicesServiceIdRouteRouteChildren {
  AppEngineeringServicesServiceIdIndexRoute: typeof AppEngineeringServicesServiceIdIndexRoute
  AppEngineeringServicesServiceIdCompositionIndexRoute: typeof AppEngineeringServicesServiceIdCompositionIndexRoute
  AppEngineeringServicesServiceIdDescriptionsIndexRoute: typeof AppEngineeringServicesServiceIdDescriptionsIndexRoute
  AppEngineeringServicesServiceIdNotesIndexRoute: typeof AppEngineeringServicesServiceIdNotesIndexRoute
  AppEngineeringServicesServiceIdOffersIndexRoute: typeof AppEngineeringServicesServiceIdOffersIndexRoute
}

const AppEngineeringServicesServiceIdRouteRouteChildren: AppEngineeringServicesServiceIdRouteRouteChildren =
  {
    AppEngineeringServicesServiceIdIndexRoute:
      AppEngineeringServicesServiceIdIndexRoute,
    AppEngineeringServicesServiceIdCompositionIndexRoute:
      AppEngineeringServicesServiceIdCompositionIndexRoute,
    AppEngineeringServicesServiceIdDescriptionsIndexRoute:
      AppEngineeringServicesServiceIdDescriptionsIndexRoute,
    AppEngineeringServicesServiceIdNotesIndexRoute:
      AppEngineeringServicesServiceIdNotesIndexRoute,
    AppEngineeringServicesServiceIdOffersIndexRoute:
      AppEngineeringServicesServiceIdOffersIndexRoute,
  }

const AppEngineeringServicesServiceIdRouteRouteWithChildren =
  AppEngineeringServicesServiceIdRouteRoute._addFileChildren(
    AppEngineeringServicesServiceIdRouteRouteChildren,
  )

interface AppEngineeringServicesFunctionsRouteRouteChildren {
  AppEngineeringServicesFunctionsIndexRoute: typeof AppEngineeringServicesFunctionsIndexRoute
}

const AppEngineeringServicesFunctionsRouteRouteChildren: AppEngineeringServicesFunctionsRouteRouteChildren =
  {
    AppEngineeringServicesFunctionsIndexRoute:
      AppEngineeringServicesFunctionsIndexRoute,
  }

const AppEngineeringServicesFunctionsRouteRouteWithChildren =
  AppEngineeringServicesFunctionsRouteRoute._addFileChildren(
    AppEngineeringServicesFunctionsRouteRouteChildren,
  )

interface AppEngineeringServicesRouteRouteChildren {
  AppEngineeringServicesServiceIdRouteRoute: typeof AppEngineeringServicesServiceIdRouteRouteWithChildren
  AppEngineeringServicesFunctionsRouteRoute: typeof AppEngineeringServicesFunctionsRouteRouteWithChildren
  AppEngineeringServicesIndexRoute: typeof AppEngineeringServicesIndexRoute
}

const AppEngineeringServicesRouteRouteChildren: AppEngineeringServicesRouteRouteChildren =
  {
    AppEngineeringServicesServiceIdRouteRoute:
      AppEngineeringServicesServiceIdRouteRouteWithChildren,
    AppEngineeringServicesFunctionsRouteRoute:
      AppEngineeringServicesFunctionsRouteRouteWithChildren,
    AppEngineeringServicesIndexRoute: AppEngineeringServicesIndexRoute,
  }

const AppEngineeringServicesRouteRouteWithChildren =
  AppEngineeringServicesRouteRoute._addFileChildren(
    AppEngineeringServicesRouteRouteChildren,
  )

interface AppEngineeringSuppliersSupplierIdRouteRouteChildren {
  AppEngineeringSuppliersSupplierIdIndexRoute: typeof AppEngineeringSuppliersSupplierIdIndexRoute
  AppEngineeringSuppliersSupplierIdContactsIndexRoute: typeof AppEngineeringSuppliersSupplierIdContactsIndexRoute
  AppEngineeringSuppliersSupplierIdNotesIndexRoute: typeof AppEngineeringSuppliersSupplierIdNotesIndexRoute
  AppEngineeringSuppliersSupplierIdOffersIndexRoute: typeof AppEngineeringSuppliersSupplierIdOffersIndexRoute
}

const AppEngineeringSuppliersSupplierIdRouteRouteChildren: AppEngineeringSuppliersSupplierIdRouteRouteChildren =
  {
    AppEngineeringSuppliersSupplierIdIndexRoute:
      AppEngineeringSuppliersSupplierIdIndexRoute,
    AppEngineeringSuppliersSupplierIdContactsIndexRoute:
      AppEngineeringSuppliersSupplierIdContactsIndexRoute,
    AppEngineeringSuppliersSupplierIdNotesIndexRoute:
      AppEngineeringSuppliersSupplierIdNotesIndexRoute,
    AppEngineeringSuppliersSupplierIdOffersIndexRoute:
      AppEngineeringSuppliersSupplierIdOffersIndexRoute,
  }

const AppEngineeringSuppliersSupplierIdRouteRouteWithChildren =
  AppEngineeringSuppliersSupplierIdRouteRoute._addFileChildren(
    AppEngineeringSuppliersSupplierIdRouteRouteChildren,
  )

interface AppEngineeringSuppliersFunctionsRouteRouteChildren {
  AppEngineeringSuppliersFunctionsIndexRoute: typeof AppEngineeringSuppliersFunctionsIndexRoute
}

const AppEngineeringSuppliersFunctionsRouteRouteChildren: AppEngineeringSuppliersFunctionsRouteRouteChildren =
  {
    AppEngineeringSuppliersFunctionsIndexRoute:
      AppEngineeringSuppliersFunctionsIndexRoute,
  }

const AppEngineeringSuppliersFunctionsRouteRouteWithChildren =
  AppEngineeringSuppliersFunctionsRouteRoute._addFileChildren(
    AppEngineeringSuppliersFunctionsRouteRouteChildren,
  )

interface AppEngineeringSuppliersRouteRouteChildren {
  AppEngineeringSuppliersSupplierIdRouteRoute: typeof AppEngineeringSuppliersSupplierIdRouteRouteWithChildren
  AppEngineeringSuppliersFunctionsRouteRoute: typeof AppEngineeringSuppliersFunctionsRouteRouteWithChildren
  AppEngineeringSuppliersIndexRoute: typeof AppEngineeringSuppliersIndexRoute
}

const AppEngineeringSuppliersRouteRouteChildren: AppEngineeringSuppliersRouteRouteChildren =
  {
    AppEngineeringSuppliersSupplierIdRouteRoute:
      AppEngineeringSuppliersSupplierIdRouteRouteWithChildren,
    AppEngineeringSuppliersFunctionsRouteRoute:
      AppEngineeringSuppliersFunctionsRouteRouteWithChildren,
    AppEngineeringSuppliersIndexRoute: AppEngineeringSuppliersIndexRoute,
  }

const AppEngineeringSuppliersRouteRouteWithChildren =
  AppEngineeringSuppliersRouteRoute._addFileChildren(
    AppEngineeringSuppliersRouteRouteChildren,
  )

interface AppSalesClientsClientIdRouteRouteChildren {
  AppSalesClientsClientIdIndexRoute: typeof AppSalesClientsClientIdIndexRoute
  AppSalesClientsClientIdContactsIndexRoute: typeof AppSalesClientsClientIdContactsIndexRoute
  AppSalesClientsClientIdNotesIndexRoute: typeof AppSalesClientsClientIdNotesIndexRoute
}

const AppSalesClientsClientIdRouteRouteChildren: AppSalesClientsClientIdRouteRouteChildren =
  {
    AppSalesClientsClientIdIndexRoute: AppSalesClientsClientIdIndexRoute,
    AppSalesClientsClientIdContactsIndexRoute:
      AppSalesClientsClientIdContactsIndexRoute,
    AppSalesClientsClientIdNotesIndexRoute:
      AppSalesClientsClientIdNotesIndexRoute,
  }

const AppSalesClientsClientIdRouteRouteWithChildren =
  AppSalesClientsClientIdRouteRoute._addFileChildren(
    AppSalesClientsClientIdRouteRouteChildren,
  )

interface AppSalesClientsRouteRouteChildren {
  AppSalesClientsClientIdRouteRoute: typeof AppSalesClientsClientIdRouteRouteWithChildren
  AppSalesClientsIndexRoute: typeof AppSalesClientsIndexRoute
}

const AppSalesClientsRouteRouteChildren: AppSalesClientsRouteRouteChildren = {
  AppSalesClientsClientIdRouteRoute:
    AppSalesClientsClientIdRouteRouteWithChildren,
  AppSalesClientsIndexRoute: AppSalesClientsIndexRoute,
}

const AppSalesClientsRouteRouteWithChildren =
  AppSalesClientsRouteRoute._addFileChildren(AppSalesClientsRouteRouteChildren)

interface AppSalesExpedientsExpedientIdRouteRouteChildren {
  AppSalesExpedientsExpedientIdIndexRoute: typeof AppSalesExpedientsExpedientIdIndexRoute
  AppSalesExpedientsExpedientIdNotesIndexRoute: typeof AppSalesExpedientsExpedientIdNotesIndexRoute
  AppSalesExpedientsExpedientIdOffersIndexRoute: typeof AppSalesExpedientsExpedientIdOffersIndexRoute
  AppSalesExpedientsExpedientIdOptionsIndexRoute: typeof AppSalesExpedientsExpedientIdOptionsIndexRoute
}

const AppSalesExpedientsExpedientIdRouteRouteChildren: AppSalesExpedientsExpedientIdRouteRouteChildren =
  {
    AppSalesExpedientsExpedientIdIndexRoute:
      AppSalesExpedientsExpedientIdIndexRoute,
    AppSalesExpedientsExpedientIdNotesIndexRoute:
      AppSalesExpedientsExpedientIdNotesIndexRoute,
    AppSalesExpedientsExpedientIdOffersIndexRoute:
      AppSalesExpedientsExpedientIdOffersIndexRoute,
    AppSalesExpedientsExpedientIdOptionsIndexRoute:
      AppSalesExpedientsExpedientIdOptionsIndexRoute,
  }

const AppSalesExpedientsExpedientIdRouteRouteWithChildren =
  AppSalesExpedientsExpedientIdRouteRoute._addFileChildren(
    AppSalesExpedientsExpedientIdRouteRouteChildren,
  )

interface AppSalesExpedientsRouteRouteChildren {
  AppSalesExpedientsExpedientIdRouteRoute: typeof AppSalesExpedientsExpedientIdRouteRouteWithChildren
  AppSalesExpedientsIndexRoute: typeof AppSalesExpedientsIndexRoute
}

const AppSalesExpedientsRouteRouteChildren: AppSalesExpedientsRouteRouteChildren =
  {
    AppSalesExpedientsExpedientIdRouteRoute:
      AppSalesExpedientsExpedientIdRouteRouteWithChildren,
    AppSalesExpedientsIndexRoute: AppSalesExpedientsIndexRoute,
  }

const AppSalesExpedientsRouteRouteWithChildren =
  AppSalesExpedientsRouteRoute._addFileChildren(
    AppSalesExpedientsRouteRouteChildren,
  )

interface AppSalesLeadsLeadIdRouteRouteChildren {
  AppSalesLeadsLeadIdIndexRoute: typeof AppSalesLeadsLeadIdIndexRoute
  AppSalesLeadsLeadIdContactsIndexRoute: typeof AppSalesLeadsLeadIdContactsIndexRoute
  AppSalesLeadsLeadIdNotesIndexRoute: typeof AppSalesLeadsLeadIdNotesIndexRoute
}

const AppSalesLeadsLeadIdRouteRouteChildren: AppSalesLeadsLeadIdRouteRouteChildren =
  {
    AppSalesLeadsLeadIdIndexRoute: AppSalesLeadsLeadIdIndexRoute,
    AppSalesLeadsLeadIdContactsIndexRoute:
      AppSalesLeadsLeadIdContactsIndexRoute,
    AppSalesLeadsLeadIdNotesIndexRoute: AppSalesLeadsLeadIdNotesIndexRoute,
  }

const AppSalesLeadsLeadIdRouteRouteWithChildren =
  AppSalesLeadsLeadIdRouteRoute._addFileChildren(
    AppSalesLeadsLeadIdRouteRouteChildren,
  )

interface AppSalesLeadsRouteRouteChildren {
  AppSalesLeadsLeadIdRouteRoute: typeof AppSalesLeadsLeadIdRouteRouteWithChildren
  AppSalesLeadsIndexRoute: typeof AppSalesLeadsIndexRoute
}

const AppSalesLeadsRouteRouteChildren: AppSalesLeadsRouteRouteChildren = {
  AppSalesLeadsLeadIdRouteRoute: AppSalesLeadsLeadIdRouteRouteWithChildren,
  AppSalesLeadsIndexRoute: AppSalesLeadsIndexRoute,
}

const AppSalesLeadsRouteRouteWithChildren =
  AppSalesLeadsRouteRoute._addFileChildren(AppSalesLeadsRouteRouteChildren)

interface AppSalesOfferTemplatesRouteRouteChildren {
  AppSalesOfferTemplatesIndexRoute: typeof AppSalesOfferTemplatesIndexRoute
}

const AppSalesOfferTemplatesRouteRouteChildren: AppSalesOfferTemplatesRouteRouteChildren =
  {
    AppSalesOfferTemplatesIndexRoute: AppSalesOfferTemplatesIndexRoute,
  }

const AppSalesOfferTemplatesRouteRouteWithChildren =
  AppSalesOfferTemplatesRouteRoute._addFileChildren(
    AppSalesOfferTemplatesRouteRouteChildren,
  )

interface AppSalesOffersOfferIdRouteRouteChildren {
  AppSalesOffersOfferIdIndexRoute: typeof AppSalesOffersOfferIdIndexRoute
  AppSalesOffersOfferIdDetailsIndexRoute: typeof AppSalesOffersOfferIdDetailsIndexRoute
  AppSalesOffersOfferIdEditorIndexRoute: typeof AppSalesOffersOfferIdEditorIndexRoute
  AppSalesOffersOfferIdHistoryIndexRoute: typeof AppSalesOffersOfferIdHistoryIndexRoute
  AppSalesOffersOfferIdNotesIndexRoute: typeof AppSalesOffersOfferIdNotesIndexRoute
  AppSalesOffersOfferIdPreviewIndexRoute: typeof AppSalesOffersOfferIdPreviewIndexRoute
}

const AppSalesOffersOfferIdRouteRouteChildren: AppSalesOffersOfferIdRouteRouteChildren =
  {
    AppSalesOffersOfferIdIndexRoute: AppSalesOffersOfferIdIndexRoute,
    AppSalesOffersOfferIdDetailsIndexRoute:
      AppSalesOffersOfferIdDetailsIndexRoute,
    AppSalesOffersOfferIdEditorIndexRoute:
      AppSalesOffersOfferIdEditorIndexRoute,
    AppSalesOffersOfferIdHistoryIndexRoute:
      AppSalesOffersOfferIdHistoryIndexRoute,
    AppSalesOffersOfferIdNotesIndexRoute: AppSalesOffersOfferIdNotesIndexRoute,
    AppSalesOffersOfferIdPreviewIndexRoute:
      AppSalesOffersOfferIdPreviewIndexRoute,
  }

const AppSalesOffersOfferIdRouteRouteWithChildren =
  AppSalesOffersOfferIdRouteRoute._addFileChildren(
    AppSalesOffersOfferIdRouteRouteChildren,
  )

interface AppSalesOffersTemplatesOfferTemplateIdRouteRouteChildren {
  AppSalesOffersTemplatesOfferTemplateIdIndexRoute: typeof AppSalesOffersTemplatesOfferTemplateIdIndexRoute
  AppSalesOffersTemplatesOfferTemplateIdDetailsIndexRoute: typeof AppSalesOffersTemplatesOfferTemplateIdDetailsIndexRoute
  AppSalesOffersTemplatesOfferTemplateIdEditorIndexRoute: typeof AppSalesOffersTemplatesOfferTemplateIdEditorIndexRoute
  AppSalesOffersTemplatesOfferTemplateIdNotesIndexRoute: typeof AppSalesOffersTemplatesOfferTemplateIdNotesIndexRoute
  AppSalesOffersTemplatesOfferTemplateIdPreviewIndexRoute: typeof AppSalesOffersTemplatesOfferTemplateIdPreviewIndexRoute
}

const AppSalesOffersTemplatesOfferTemplateIdRouteRouteChildren: AppSalesOffersTemplatesOfferTemplateIdRouteRouteChildren =
  {
    AppSalesOffersTemplatesOfferTemplateIdIndexRoute:
      AppSalesOffersTemplatesOfferTemplateIdIndexRoute,
    AppSalesOffersTemplatesOfferTemplateIdDetailsIndexRoute:
      AppSalesOffersTemplatesOfferTemplateIdDetailsIndexRoute,
    AppSalesOffersTemplatesOfferTemplateIdEditorIndexRoute:
      AppSalesOffersTemplatesOfferTemplateIdEditorIndexRoute,
    AppSalesOffersTemplatesOfferTemplateIdNotesIndexRoute:
      AppSalesOffersTemplatesOfferTemplateIdNotesIndexRoute,
    AppSalesOffersTemplatesOfferTemplateIdPreviewIndexRoute:
      AppSalesOffersTemplatesOfferTemplateIdPreviewIndexRoute,
  }

const AppSalesOffersTemplatesOfferTemplateIdRouteRouteWithChildren =
  AppSalesOffersTemplatesOfferTemplateIdRouteRoute._addFileChildren(
    AppSalesOffersTemplatesOfferTemplateIdRouteRouteChildren,
  )

interface AppSalesOffersTemplatesRouteRouteChildren {
  AppSalesOffersTemplatesOfferTemplateIdRouteRoute: typeof AppSalesOffersTemplatesOfferTemplateIdRouteRouteWithChildren
  AppSalesOffersTemplatesIndexRoute: typeof AppSalesOffersTemplatesIndexRoute
  AppSalesOffersTemplatesEditorOfferTemplateIdIndexRoute: typeof AppSalesOffersTemplatesEditorOfferTemplateIdIndexRoute
}

const AppSalesOffersTemplatesRouteRouteChildren: AppSalesOffersTemplatesRouteRouteChildren =
  {
    AppSalesOffersTemplatesOfferTemplateIdRouteRoute:
      AppSalesOffersTemplatesOfferTemplateIdRouteRouteWithChildren,
    AppSalesOffersTemplatesIndexRoute: AppSalesOffersTemplatesIndexRoute,
    AppSalesOffersTemplatesEditorOfferTemplateIdIndexRoute:
      AppSalesOffersTemplatesEditorOfferTemplateIdIndexRoute,
  }

const AppSalesOffersTemplatesRouteRouteWithChildren =
  AppSalesOffersTemplatesRouteRoute._addFileChildren(
    AppSalesOffersTemplatesRouteRouteChildren,
  )

interface AppSalesOffersRouteRouteChildren {
  AppSalesOffersOfferIdRouteRoute: typeof AppSalesOffersOfferIdRouteRouteWithChildren
  AppSalesOffersTemplatesRouteRoute: typeof AppSalesOffersTemplatesRouteRouteWithChildren
  AppSalesOffersIndexRoute: typeof AppSalesOffersIndexRoute
  AppSalesOffersEditorCustomerOfferIdIndexRoute: typeof AppSalesOffersEditorCustomerOfferIdIndexRoute
}

const AppSalesOffersRouteRouteChildren: AppSalesOffersRouteRouteChildren = {
  AppSalesOffersOfferIdRouteRoute: AppSalesOffersOfferIdRouteRouteWithChildren,
  AppSalesOffersTemplatesRouteRoute:
    AppSalesOffersTemplatesRouteRouteWithChildren,
  AppSalesOffersIndexRoute: AppSalesOffersIndexRoute,
  AppSalesOffersEditorCustomerOfferIdIndexRoute:
    AppSalesOffersEditorCustomerOfferIdIndexRoute,
}

const AppSalesOffersRouteRouteWithChildren =
  AppSalesOffersRouteRoute._addFileChildren(AppSalesOffersRouteRouteChildren)

interface AppSalesRepresentativesRepresentativeIdRouteRouteChildren {
  AppSalesRepresentativesRepresentativeIdIndexRoute: typeof AppSalesRepresentativesRepresentativeIdIndexRoute
  AppSalesRepresentativesRepresentativeIdCommissionsIndexRoute: typeof AppSalesRepresentativesRepresentativeIdCommissionsIndexRoute
  AppSalesRepresentativesRepresentativeIdContactsIndexRoute: typeof AppSalesRepresentativesRepresentativeIdContactsIndexRoute
  AppSalesRepresentativesRepresentativeIdNotesIndexRoute: typeof AppSalesRepresentativesRepresentativeIdNotesIndexRoute
}

const AppSalesRepresentativesRepresentativeIdRouteRouteChildren: AppSalesRepresentativesRepresentativeIdRouteRouteChildren =
  {
    AppSalesRepresentativesRepresentativeIdIndexRoute:
      AppSalesRepresentativesRepresentativeIdIndexRoute,
    AppSalesRepresentativesRepresentativeIdCommissionsIndexRoute:
      AppSalesRepresentativesRepresentativeIdCommissionsIndexRoute,
    AppSalesRepresentativesRepresentativeIdContactsIndexRoute:
      AppSalesRepresentativesRepresentativeIdContactsIndexRoute,
    AppSalesRepresentativesRepresentativeIdNotesIndexRoute:
      AppSalesRepresentativesRepresentativeIdNotesIndexRoute,
  }

const AppSalesRepresentativesRepresentativeIdRouteRouteWithChildren =
  AppSalesRepresentativesRepresentativeIdRouteRoute._addFileChildren(
    AppSalesRepresentativesRepresentativeIdRouteRouteChildren,
  )

interface AppSalesRepresentativesRouteRouteChildren {
  AppSalesRepresentativesRepresentativeIdRouteRoute: typeof AppSalesRepresentativesRepresentativeIdRouteRouteWithChildren
  AppSalesRepresentativesIndexRoute: typeof AppSalesRepresentativesIndexRoute
}

const AppSalesRepresentativesRouteRouteChildren: AppSalesRepresentativesRouteRouteChildren =
  {
    AppSalesRepresentativesRepresentativeIdRouteRoute:
      AppSalesRepresentativesRepresentativeIdRouteRouteWithChildren,
    AppSalesRepresentativesIndexRoute: AppSalesRepresentativesIndexRoute,
  }

const AppSalesRepresentativesRouteRouteWithChildren =
  AppSalesRepresentativesRouteRoute._addFileChildren(
    AppSalesRepresentativesRouteRouteChildren,
  )

interface AppUserManagementUsersUserIdRouteRouteChildren {
  AppUserManagementUsersUserIdIndexRoute: typeof AppUserManagementUsersUserIdIndexRoute
  AppUserManagementUsersUserIdPermissionsIndexRoute: typeof AppUserManagementUsersUserIdPermissionsIndexRoute
  AppUserManagementUsersUserIdRolesIndexRoute: typeof AppUserManagementUsersUserIdRolesIndexRoute
}

const AppUserManagementUsersUserIdRouteRouteChildren: AppUserManagementUsersUserIdRouteRouteChildren =
  {
    AppUserManagementUsersUserIdIndexRoute:
      AppUserManagementUsersUserIdIndexRoute,
    AppUserManagementUsersUserIdPermissionsIndexRoute:
      AppUserManagementUsersUserIdPermissionsIndexRoute,
    AppUserManagementUsersUserIdRolesIndexRoute:
      AppUserManagementUsersUserIdRolesIndexRoute,
  }

const AppUserManagementUsersUserIdRouteRouteWithChildren =
  AppUserManagementUsersUserIdRouteRoute._addFileChildren(
    AppUserManagementUsersUserIdRouteRouteChildren,
  )

interface AppUserManagementUsersRolesRoleIdRouteRouteChildren {
  AppUserManagementUsersRolesRoleIdIndexRoute: typeof AppUserManagementUsersRolesRoleIdIndexRoute
  AppUserManagementUsersRolesRoleIdPermissionsIndexRoute: typeof AppUserManagementUsersRolesRoleIdPermissionsIndexRoute
}

const AppUserManagementUsersRolesRoleIdRouteRouteChildren: AppUserManagementUsersRolesRoleIdRouteRouteChildren =
  {
    AppUserManagementUsersRolesRoleIdIndexRoute:
      AppUserManagementUsersRolesRoleIdIndexRoute,
    AppUserManagementUsersRolesRoleIdPermissionsIndexRoute:
      AppUserManagementUsersRolesRoleIdPermissionsIndexRoute,
  }

const AppUserManagementUsersRolesRoleIdRouteRouteWithChildren =
  AppUserManagementUsersRolesRoleIdRouteRoute._addFileChildren(
    AppUserManagementUsersRolesRoleIdRouteRouteChildren,
  )

interface AppUserManagementUsersRolesRouteRouteChildren {
  AppUserManagementUsersRolesRoleIdRouteRoute: typeof AppUserManagementUsersRolesRoleIdRouteRouteWithChildren
  AppUserManagementUsersRolesIndexRoute: typeof AppUserManagementUsersRolesIndexRoute
}

const AppUserManagementUsersRolesRouteRouteChildren: AppUserManagementUsersRolesRouteRouteChildren =
  {
    AppUserManagementUsersRolesRoleIdRouteRoute:
      AppUserManagementUsersRolesRoleIdRouteRouteWithChildren,
    AppUserManagementUsersRolesIndexRoute:
      AppUserManagementUsersRolesIndexRoute,
  }

const AppUserManagementUsersRolesRouteRouteWithChildren =
  AppUserManagementUsersRolesRouteRoute._addFileChildren(
    AppUserManagementUsersRolesRouteRouteChildren,
  )

interface AppUserManagementUsersRouteRouteChildren {
  AppUserManagementUsersUserIdRouteRoute: typeof AppUserManagementUsersUserIdRouteRouteWithChildren
  AppUserManagementUsersRolesRouteRoute: typeof AppUserManagementUsersRolesRouteRouteWithChildren
  AppUserManagementUsersIndexRoute: typeof AppUserManagementUsersIndexRoute
}

const AppUserManagementUsersRouteRouteChildren: AppUserManagementUsersRouteRouteChildren =
  {
    AppUserManagementUsersUserIdRouteRoute:
      AppUserManagementUsersUserIdRouteRouteWithChildren,
    AppUserManagementUsersRolesRouteRoute:
      AppUserManagementUsersRolesRouteRouteWithChildren,
    AppUserManagementUsersIndexRoute: AppUserManagementUsersIndexRoute,
  }

const AppUserManagementUsersRouteRouteWithChildren =
  AppUserManagementUsersRouteRoute._addFileChildren(
    AppUserManagementUsersRouteRouteChildren,
  )

interface AppRouteRouteChildren {
  AppAdminUsersRouteRoute: typeof AppAdminUsersRouteRouteWithChildren
  AppEngineeringMaterialFunctionsRouteRoute: typeof AppEngineeringMaterialFunctionsRouteRouteWithChildren
  AppEngineeringMaterialsRouteRoute: typeof AppEngineeringMaterialsRouteRouteWithChildren
  AppEngineeringServicesRouteRoute: typeof AppEngineeringServicesRouteRouteWithChildren
  AppEngineeringSuppliersRouteRoute: typeof AppEngineeringSuppliersRouteRouteWithChildren
  AppSalesClientsRouteRoute: typeof AppSalesClientsRouteRouteWithChildren
  AppSalesExpedientsRouteRoute: typeof AppSalesExpedientsRouteRouteWithChildren
  AppSalesLeadsRouteRoute: typeof AppSalesLeadsRouteRouteWithChildren
  AppSalesOfferTemplatesRouteRoute: typeof AppSalesOfferTemplatesRouteRouteWithChildren
  AppSalesOffersRouteRoute: typeof AppSalesOffersRouteRouteWithChildren
  AppSalesRepresentativesRouteRoute: typeof AppSalesRepresentativesRouteRouteWithChildren
  AppUserManagementUsersRouteRoute: typeof AppUserManagementUsersRouteRouteWithChildren
  AppDashboardIndexRoute: typeof AppDashboardIndexRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppDevDashboardIndexRoute: typeof AppDevDashboardIndexRoute
  AppDiagramDiagramIdIndexRoute: typeof AppDiagramDiagramIdIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppAdminUsersRouteRoute: AppAdminUsersRouteRouteWithChildren,
  AppEngineeringMaterialFunctionsRouteRoute:
    AppEngineeringMaterialFunctionsRouteRouteWithChildren,
  AppEngineeringMaterialsRouteRoute:
    AppEngineeringMaterialsRouteRouteWithChildren,
  AppEngineeringServicesRouteRoute:
    AppEngineeringServicesRouteRouteWithChildren,
  AppEngineeringSuppliersRouteRoute:
    AppEngineeringSuppliersRouteRouteWithChildren,
  AppSalesClientsRouteRoute: AppSalesClientsRouteRouteWithChildren,
  AppSalesExpedientsRouteRoute: AppSalesExpedientsRouteRouteWithChildren,
  AppSalesLeadsRouteRoute: AppSalesLeadsRouteRouteWithChildren,
  AppSalesOfferTemplatesRouteRoute:
    AppSalesOfferTemplatesRouteRouteWithChildren,
  AppSalesOffersRouteRoute: AppSalesOffersRouteRouteWithChildren,
  AppSalesRepresentativesRouteRoute:
    AppSalesRepresentativesRouteRouteWithChildren,
  AppUserManagementUsersRouteRoute:
    AppUserManagementUsersRouteRouteWithChildren,
  AppDashboardIndexRoute: AppDashboardIndexRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppDevDashboardIndexRoute: AppDevDashboardIndexRoute,
  AppDiagramDiagramIdIndexRoute: AppDiagramDiagramIdIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  AccountNotLinkedRoute: AccountNotLinkedRoute,
  LoginRoute: LoginRoute,
  SignedOutRoute: SignedOutRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
